webpackJsonp([1],{

/***/ "+0oY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_business_days__ = __webpack_require__("w4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_business_days__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Make whole room clickable to trigger roomReport


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SuccinctReports',
  data: function data() {
    var now = Date.now();
    return {
      rawSearchTerms: '',
      searchTimeout: -1,
      debouncePeriod: 500,
      console: console,
      searchKeys: ['active_status', 'campus', 'campus_region', 'customer_or_owner', 'email_primary_owner', 'email_secondary_owner', 'label', 'netid_primary_owner', 'primary_contact_name', 'room_type', 'secondary_contact_name', 'secondary_customer_or_owner'],
      filter: {
        searchTerms: '',
        roomOwner: '',
        roomOrgUnit: '',
        roomCampusRegion: '',
        onlyOverdue: false,
        startDate: __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(now).subtract(1, 'y').format('YYYY-MM-DD'),
        endDate: this.utcString(now)
      },
      pagination: {
        sortBy: 'last_checked',
        descending: true,
        rowsPerPage: -1,
        page: 1
      },
      baseReportsTableHeaders: [{
        text: 'Actions',
        align: 'center',
        sortable: false
      }, {
        text: 'Room',
        align: 'left',
        value: 'label'
      }, {
        text: 'Dept. / Unit',
        align: 'left',
        value: 'org_unit.value',
        sortable: true
      }, {
        text: 'Campus',
        align: 'left',
        value: 'campus',
        sortable: true
      }, {
        text: 'Region',
        align: 'left',
        value: 'campus_region',
        sortable: true
      }, {
        text: 'Frequency',
        align: 'right',
        value: 'minimum_frequency',
        sortable: true
      }, {
        text: 'Last Checked',
        align: 'left',
        value: 'last_checked'
      }, {
        text: 'Incidents',
        align: 'right',
        value: 'incidentCount',
        sortable: true
      }, {
        text: 'Checks',
        align: 'right',
        value: 'checkCount',
        sortable: true
      }, {
        text: 'Min Checks*',
        align: 'right',
        value: 'minimumCheckCount',
        sortable: true,
        tooltipOpen: false,
        tooltip: {
          text: 'Calculated from the oldest check in the date range until now'
        }
      }, {
        text: 'Check %',
        align: 'right',
        value: 'checkPercent',
        sortable: true
      }],
      startDatePicker: false,
      endDatePicker: false,
      roomReportDialog: false,
      roomReportRoomId: null,
      now: now
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    startReport: function startReport(roomId) {
      var teamId = this.teamId;
      this.$router.push({
        path: '/' + teamId + '/report/' + roomId
      });
    },
    loadData: function loadData() {
      this.$reportService.refreshData(this.teamId);
      this.$roomService.refreshData(this.teamId);
    },
    customSearchFilter: function customSearchFilter(items, search, filter) {
      var _this = this;

      search = search.toString().toLowerCase();

      if (this.filter.onlyOverdue) {
        items = items.filter(function (it) {
          return it.check_overdue;
        });
      }

      // Apply organizational owner filter
      if (this.filter.roomOrgUnit) {
        items = items.filter(function (it) {
          return it.org_unit.line1 === _this.filter.roomOrgUnit || it.org_unit.value === _this.filter.roomOrgUnit;
        });
      }

      // Apply room owner filter
      if (this.filter.roomOwner) {
        items = items.filter(function (it) {
          return it.netid_primary_owner === _this.filter.roomOwner || it.netid_secondary_owner === _this.filter.roomOwner;
        });
      }

      // Apply region filter
      if (this.filter.roomCampusRegion) {
        var _filter$roomCampusReg = this.filter.roomCampusRegion.split(' - '),
            _filter$roomCampusReg2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_filter$roomCampusReg, 2),
            campus = _filter$roomCampusReg2[0],
            region = _filter$roomCampusReg2[1];
        // debugger;


        items = items.filter(function (it) {
          return it.campus === campus;
        });
        if (region) items = items.filter(function (it) {
          return it.campus_region === region;
        });
      }

      // Apply keyword search filters
      if (search) {
        // Split the search terms up by space, and search for all of them
        var searchTerms = search.split(" ").filter(function (term) {
          return term;
        });
        items = items.filter(function (i) {
          return searchTerms.every(function (term) {
            return _this.searchKeys.some(function (j) {
              return filter(i[j], term);
            });
          });
        });
      }

      return items;
    },
    changeSort: function changeSort(header) {
      if (header.sortable !== false) {
        var column = header.value;
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    openRoomReport: function openRoomReport(roomId) {
      this.roomReportRoomId = roomId;
      this.roomReportDialog = true;
    },
    closeRoomReport: function closeRoomReport() {
      // this.roomReportRoomId = null; // TODO: Maybe re-enable this?
      this.roomReportDialog = false;
    },
    getStatusIcon: function getStatusIcon(status) {
      if (status === true) {
        return {
          color: 'success',
          icon: 'check_circle'
        };
      } else if (status === false) {
        return {
          color: 'warning',
          icon: 'warning'
        };
      } else {
        return {
          color: 'grey lighten-1',
          icon: 'do_not_disturb_on'
        };
      }
    },
    utcString: function utcString(time) {
      return __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(time).format('YYYY-MM-DD');
    },
    finishSearchDebounce: function finishSearchDebounce() {
      this.filter.searchTerms = this.rawSearchTerms;
    },
    downloadCSV: function downloadCSV() {
      var _this2 = this;

      var noActionHeaders = this.reportsTableHeaders.filter(function (th) {
        return th.text !== "Actions";
      });
      var headers = noActionHeaders.filter(function (th) {
        return !th.hide;
      }).map(function (th) {
        return th.text.replace('*', '');
      });
      var data = this.filteredReportsTableItems.map(function (room) {
        return [room.label, room.org_unit.value.replace(/^ - | - $/, ''), room.campus, room.campus_region, room.minimum_frequency + ' Days', _this2.dateFilter(room.last_checked), room.incidentCount, room.checkCount, room.minimumCheckCount, _this2.sub100PercentFilter(room.checkPercent)].filter(function (_, i) {
          return !noActionHeaders[i].hide;
        }).map(function (val) {
          return val && val.includes && val.includes('"') ? '"' + val.replace(/"/g, '\"') + '"' : val;
        });
      });
      var csvText = headers.join(',') + '\n' + data.map(function (row) {
        return row.join(',');
      }).join('\n');

      var filter = this.filter;
      function errDefault(f) {
        var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        try {
          return f();
        } catch (e) {
          return def;
        }
      }
      var filename = ['roomready', filter.searchTerms && 'search', filter.roomOwner, errDefault(function () {
        return filter.roomOrgUnit.match(/^\S+/)[0];
      }), errDefault(function () {
        return filter.roomOrgUnit.match(/ - (^\S+)/)[1];
      }), filter.startDate, filter.endDate].filter(function (item) {
        return item;
      }).join('_') + '.csv';
      var url = 'data:text/csv,' + filename;
      this.download(filename, csvText, 'text/csv');
    },
    download: function download(filename, text) {
      var mimeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text/plaincharset=utf-8';

      var el = document.createElement('a');
      el.href = 'data:' + mimeType + ',' + encodeURIComponent(text);
      el.download = filename;
      el.click();
    },
    dateFilter: function dateFilter(timestamp) {
      return timestamp ? __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(timestamp, 'x').format('MM/DD/YYYY h:mma') : 'Never';
    },
    sub100PercentFilter: function sub100PercentFilter(number) {
      return isNaN(number) ? undefined : number >= 1 ? '100%' : Math.round(number * 100) + '%';
    }
  },
  computed: {
    reportsTableHeaders: function reportsTableHeaders() {
      this.baseReportsTableHeaders.find(function (h) {
        return h.value === 'org_unit.value';
      }).hide = !this.showDepartmentUnit;
      return this.baseReportsTableHeaders;
    },
    reportsForTimePeriod: function reportsForTimePeriod() {
      var _this3 = this;

      return this.$reportService.reports.filter(function (it) {
        return it.date_only_timestamp && __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(it.date_only_timestamp).isBetween(_this3.moments.startDate, _this3.moments.endDate, 'day', '[]');
      });
    },
    reportsByRoom: function reportsByRoom() {
      var reports = this.reportsForTimePeriod;
      var result = {};
      reports.forEach(function (report) {
        if (!result[report.room_id]) result[report.room_id] = [];
        !result[report.room_id].push(report);
      });
      return result;
    },
    reportsTableItems: function reportsTableItems() {
      var _this4 = this;

      var rooms = this.$roomService.rooms.slice();
      var reports = this.reportsForTimePeriod;
      if (!(rooms && reports)) return [];

      rooms.forEach(function (room) {
        // Add data for department / unit column
        room.org_unit = {
          value: null,
          line1: room.customer_or_owner || '',
          line2: room.secondary_customer_or_owner || ''
        };
        room.org_unit.value = room.org_unit.line1 + ' - ' + room.org_unit.line2;
      });
      // Don't populate other fields if reports haven't loaded
      if (!reports.length) return rooms;__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', rooms.forEach(function (room, i) {
                  // Check for and mark whether rooms are overdue
                  var business_days_since_check = __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(room.last_checked, 'x').endOf('day').businessDiff(_this4.moments.now.endOf('day'));
                  room.check_status_color_class = '';
                  if (business_days_since_check > room.minimum_frequency || !room.last_checked) {
                    room.check_status_color_class = 'error--text';
                    room.check_overdue = true;
                  } else {
                    room.check_overdue = false;
                  }

                  // Insert report and incident counts into the room object
                  var relevantReports = _this4.reportsByRoom[room.room_id] || [];
                  room.checkCount = relevantReports.length;
                  room.incidentCount = 0;
                  relevantReports.forEach(function (report) {
                    room.incidentCount += !report.room_status;
                  });
                  // Determine if room is being reported on enough
                  var reportingStart = relevantReports.reduce(function (start, it) {
                    return it.timestamp < start.timestamp ? it : start;
                  }, { timestamp: Infinity });
                  var reportingDuration = __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(reportingStart.timestamp, 'x').endOf('day').businessDiff(_this4.moments.now.endOf('day'));
                  room.minimumCheckCount = Math.floor(reportingDuration / room.minimum_frequency);
                  if (isNaN(room.minimumCheckCount)) room.minimumCheckCount = 0;
                  room.checkPercent = room.checkCount / room.minimumCheckCount;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
      return rooms;
    },
    filteredReportsTableItems: function filteredReportsTableItems() {
      return this.$refs.reportsTable.filteredItems;
    },
    roomReportLabel: function roomReportLabel() {
      if (this.roomReportRoomId) {
        return this.$roomService.getRoom(this.roomReportRoomId).label;
      }
      return '';
    },
    roomReportTableHeaders: function roomReportTableHeaders() {
      if (this.roomReportRoomId) {
        var headers = [{
          text: "Status",
          align: "center",
          sortable: false,
          value: "room_status"
        }, {
          text: "Date",
          align: "left",
          sortable: false,
          value: "timestamp"
        }, {
          text: "Notes",
          align: "left",
          sortable: false,
          value: "room_status"
        }];
        return headers;
      }
      return [];
    },
    roomReportTableItems: function roomReportTableItems() {
      var _this5 = this;

      if (this.roomReportRoomId) {
        return this.$reportService.reports.filter(function (it) {
          return it.room_id == _this5.roomReportRoomId;
        }).reverse().map(function (report) {
          report.inventory = _this5.$roomService.getRoomInventory(report.room_id).filter(function (feature) {
            return report[feature.featureId] === false || report[feature.featureId + '_issue_description'];
          });
          if (!report.inventory.length) {
            report.clean_report = true;
            report.clean_report_issue_description = '';
            report.inventory.push({
              featureId: 'clean_report',
              featureName: 'No Issues Reported'
            });
          }
          return report;
        });
      }
      return [];
    },
    roomOwners: function roomOwners() {
      var rooms = this.$roomService.rooms;
      var owners = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.filter(function (it) {
        return !!it.netid_primary_owner && !!it.primary_contact_name;
      }).map(function (it) {
        return {
          value: it.netid_primary_owner,
          label: it.primary_contact_name
        };
      }).concat(rooms.filter(function (it) {
        return !!it.netid_secondary_owner && !!it.secondary_contact_name;
      }).map(function (it) {
        return {
          value: it.netid_secondary_owner,
          label: it.secondary_contact_name
        };
      }))));
      return owners;
    },
    roomCampusRegions: function roomCampusRegions() {
      var rooms = this.$roomService.rooms;
      var campusRegions = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      rooms.forEach(function (it) {
        var campus = it.campus,
            campus_region = it.campus_region;

        if (campus) campusRegions.add(campus);
        if (campus_region) campusRegions.add(campus + " - " + campus_region);
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(campusRegions).sort();
    },
    roomOrgUnits: function roomOrgUnits() {
      var rooms = this.$roomService.rooms;
      var orgUnits = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.filter(function (it) {
        return it.customer_or_owner;
      }).map(function (it) {
        return it.customer_or_owner;
      }).concat(rooms.filter(function (it) {
        return it.customer_or_owner && it.secondary_customer_or_owner;
      }).map(function (it) {
        return it.customer_or_owner + " - " + it.secondary_customer_or_owner;
      })))).sort();
      return orgUnits;
    },
    viewerIsRoomOwner: function viewerIsRoomOwner() {
      var _this6 = this;

      return !!this.roomOwners.filter(function (it) {
        return it.value == _this6.$auth.user().uid;
      }).length;
    },
    showDepartmentUnit: function showDepartmentUnit() {
      return !!this.roomOrgUnits.length;
    },
    lastChecked: function lastChecked() {
      var prefix = 'Last Updated: ';
      if (this.$roomService.rooms) {
        var lastRoomsChecked = this.$roomService.rooms.filter(function (it) {
          return !!it.last_checked;
        }).map(function (it) {
          return it.last_checked;
        }).sort().reverse();
        if (lastRoomsChecked.length) {
          return prefix + __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(lastRoomsChecked[0], 'x').format('M/D/YY') + ' at ' + __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(lastRoomsChecked[0], 'x').format('h:mma');
        }
        return prefix + 'Never';
      }
      return 'Loading...';
    },
    displayDates: function displayDates() {
      return {
        startDate: this.moments.startDate.format('MMM D YYYY'),
        endDate: this.moments.endDate.format('MMM D YYYY')
      };
    },
    moments: function moments() {
      return {
        startDate: __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(this.filter.startDate),
        endDate: __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(this.filter.endDate),
        now: __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(this.now)
      };
    }
  },
  watch: {
    rawSearchTerms: function rawSearchTerms() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(this.finishSearchDebounce, this.debouncePeriod);
    }
  },
  filters: {
    date: function date(timestamp) {
      return timestamp ? __WEBPACK_IMPORTED_MODULE_5_moment_business_days___default()(timestamp, 'x').format('MM/DD/YYYY h:mma') : 'Never';
    },
    sub100Percent: function sub100Percent(number) {
      return isNaN(number) ? undefined : number >= 1 ? '100%' : Math.round(number * 100) + '%';
    }
  }
});

/***/ }),

/***/ "+A0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    team: function team() {
      return this.$teamService.getTeam(this.teamId);
    }
  },
  methods: {
    start: function start() {
      this.$router.push({ name: 'RoomPicker', params: { teamId: this.teamId } });
    },
    logout: function logout() {
      this.$auth.logout();
    }
  }
});

/***/ }),

/***/ "+oK5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Bold.b5ab3c2.woff2";

/***/ }),

/***/ "/1w6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Color code sync buttons for each row based on status




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sync',
  data: function data() {
    return {
      syncStatusIcons: { // TODO: Move item & queue status icons/colors into syncService
        pending: {
          color: 'warning',
          icon: 'sync'
        },
        sending: {
          color: 'secondary',
          icon: 'sync'
        },
        failed: {
          color: 'error',
          icon: 'sync'
        },
        success: {
          color: 'success',
          icon: 'sync'
        }
      }
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    items: function items() {
      var _this = this;

      return this.$syncService.items.filter(function (it) {
        return it.teamId === _this.teamId;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    add: function add(item) {
      this.$syncService.add(item);
    },
    resetSyncStore: function resetSyncStore() {
      this.$syncService.clearQueue();
    },
    loadData: function loadData() {}
  },
  filters: {
    date: function date(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp, 'x').format('MM/DD/YYYY h:mma');
    }
  }
});

/***/ }),

/***/ "/UJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "roompicker-page content-500" },
        [
          _c("h2", { staticClass: "page-title" }, [_vm._v("Room Picker")]),
          _vm._v(" "),
          _c("form", [
            _c(
              "div",
              { staticClass: "picker-form" },
              [
                _c("v-select", {
                  staticClass: "select__campus",
                  attrs: {
                    disabled: _vm.roomsLoading,
                    loading: _vm.roomsLoading,
                    items: _vm.campuses,
                    "item-text": "label",
                    label: "Select Campus"
                  },
                  model: {
                    value: _vm.campusAndRegionSelection,
                    callback: function($$v) {
                      _vm.campusAndRegionSelection = $$v
                    },
                    expression: "campusAndRegionSelection"
                  }
                }),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "select__building",
                  attrs: {
                    disabled: _vm.roomsLoading,
                    loading: _vm.roomsLoading,
                    items: _vm.buildings,
                    label: "Select Building",
                    autocomplete: ""
                  },
                  model: {
                    value: _vm.buildingSelection,
                    callback: function($$v) {
                      _vm.buildingSelection = $$v
                    },
                    expression: "buildingSelection"
                  }
                }),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "select__room",
                  attrs: {
                    disabled: _vm.roomsLoading,
                    loading: _vm.roomsLoading,
                    items: _vm.rooms,
                    "item-text": "selectLabel",
                    "item-value": "room_id",
                    label: "Select Room",
                    autocomplete: ""
                  },
                  model: {
                    value: _vm.roomSelection,
                    callback: function($$v) {
                      _vm.roomSelection = $$v
                    },
                    expression: "roomSelection"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn__reset_form",
                        attrs: {
                          disabled:
                            _vm.roomSelection === null &&
                            _vm.buildingSelection === null &&
                            _vm.campusSelection === null,
                          color: "error",
                          flat: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.resetForm()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("remove_circle_outline")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Clear Filters")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn__start_report",
                        attrs: { disabled: _vm.roomSelection === null },
                        on: {
                          click: function($event) {
                            return _vm.startReport()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [_vm._v("edit")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Start Report")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.recentlyCheckedRooms.length
            ? _c(
                "v-layout",
                { staticClass: "recent_room_checks mt-5" },
                [
                  _c("v-flex", [
                    _c("div", { staticClass: "title mb-1" }, [
                      _vm._v("Recent Room Checks")
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "table table__report" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass:
                                  "text-xs-left pr-1 pl-0 body-2 activity_column--room_label",
                                attrs: { role: "columnheader" }
                              },
                              [_vm._v("Room")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass:
                                  "text-xs-right pr-0 pl-1 body-2 activity_column--room_last_checked",
                                attrs: { role: "columnheader" }
                              },
                              [_vm._v("Last Check")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.recentlyCheckedRooms, function(item, index) {
                          return [
                            _c(
                              "tr",
                              {
                                key: index,
                                staticClass: "field",
                                attrs: { ripple: "" }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-xs-left py-1 pr-1 pl-0 body-1 activity_column--room_label"
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-xs-right py-1 pr-0 pl-1 body-1 activity_column--room_last_checked"
                                  },
                                  [
                                    _c("em", [
                                      _vm._v(_vm._s(item.last_checked_time_ago))
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db7d1a0e", esExports)
  }
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Act":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var eventService = {
  install: function install(Vue, options) {
    var eventServiceVue = new Vue({});
    Vue.prototype.$eventService = eventServiceVue;
    Vue.eventService = eventServiceVue;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (eventService);

/***/ }),

/***/ "0jRs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kP2y");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("38678604", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29ce9aa7\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FlashMessage.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29ce9aa7\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FlashMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0w89":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iLTI4OSAzODEuMiAzMS44IDMxLjgiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTI4OSAzODEuMiAzMS44IDMxLjgiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0tMjg3LjcsMzkzLjdjLTAuNywwLjMtMS4yLDAuOS0xLjMsMS42Yy0wLjEsMC43LDAuMiwxLjQsMC44LDEuOWw2LjUsNC43bDIzLjEtMTguMWwtMjAuNCwyMC4xbDguOSw2LjUNCgkJCWMwLjYsMC40LDEuMywwLjUsMiwwLjNjMC43LTAuMiwxLjItMC43LDEuNC0xLjRsOS41LTI2YzAuMS0wLjMsMC0wLjYtMC4yLTAuOGMtMC4yLTAuMi0wLjUtMC4zLTAuOC0wLjJMLTI4Ny43LDM5My43eiIvPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNLTI4My4yLDQwMy40bDAuMSwwLjNsMS4zLDYuOWMwLjEsMC41LDAuNCwwLjksMC45LDEuMWMwLjUsMC4yLDEsMC4yLDEuNS0wLjFjMS44LTEuMSw0LTIuNiw0LTIuNw0KCQkJTC0yODMuMiw0MDMuNHoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "1elP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMS45IDMxIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMS45IDMxIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xMC45LDBDNC45LDAsMCw1LjUsMCwxMC45QzAsMjAuMSwxMC45LDMxLDEwLjksMzFzMTAuOS0xMC45LDEwLjktMjAuMUMyMS45LDUuNSwxNywwLDEwLjksMHogTTYuMSwxMC45DQoJYzAtMi43LDIuMi00LjgsNC44LTQuOHM0LjgsMi4yLDQuOCw0LjhjMCwyLjctMi4yLDQuOC00LjgsNC44UzYuMSwxMy42LDYuMSwxMC45eiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "1fe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_roundsApiEndpoints__ = __webpack_require__("toSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");








// Team Service Plugin

var TeamService = function () {
  function TeamService(Vue) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TeamService);

    var self = this;
    this.Vue = Vue;
    this._store = Vue.teamsStore;
    this.watch = new Vue({
      data: function data() {
        return {
          updateCounter: 1,
          permalinks: []
        };
      },

      computed: {
        currentTeamId: function currentTeamId() {
          // stub update counter forces update of computed properties when dependencies change
          var stub = this.updateCounter;
          if (self.Vue.currentTeam && self.Vue.currentTeam.teamId) {
            return self.Vue.currentTeam.teamId;
          } else if (!!__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute && !!__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.params && !!__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.params.teamId) {
            return __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].currentRoute.params.teamId;
          }
          return null;
        },
        currentTeam: function currentTeam() {
          return self.getTeam(this.currentTeamId);
        },
        currentUserTeamIds: function currentUserTeamIds() {
          if (!!this.$auth.user().teams) {
            return this.$auth.user().teams;
          } else {
            return [];
          }
        },
        currentUserTeams: function currentUserTeams() {
          var _this = this;

          return self.teams.filter(function (team) {
            return !!_this.currentUserTeamIds.filter(function (it) {
              return it === team.teamId;
            }).length;
          });
        }
      }
    });

    // Install before hook to router to set currentTeam when teamId parameter exists in route
    __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeHooks.push(function (to, from, next) {
      if (to.params && to.params.teamId) {
        _this2.Vue.set(_this2.Vue, 'currentTeam', _this2.getTeam(to.params.teamId));
      } else {
        _this2.Vue.set(_this2.Vue, 'currentTeam', null);
      }
      _this2.watch.updateCounter++;
      next();
    });

    // Fetch data on instantiation
    if (this.Vue.$auth.watch.authenticated) {
      this.refreshData().then(function (teams) {
        _this2.Vue.$roomService.preCacheRoomsForCurrentUserTeams();
      });
    } else {
      this.Vue.$auth.userLoginSuccessful().then(function () {
        _this2.refreshData().then(function (teams) {
          _this2.Vue.$roomService.preCacheRoomsForCurrentUserTeams();
        });
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TeamService, [{
    key: 'refreshData',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var options, url, res, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                options = {
                  credentials: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };
                url = __WEBPACK_IMPORTED_MODULE_5__constants_roundsApiEndpoints__["h" /* API_ENDPOINT_TEAMS */];
                _context.next = 5;
                return this.Vue.http.get(url);

              case 5:
                res = _context.sent;
                _context.next = 8;
                return res.json();

              case 8:
                response = _context.sent;


                // Success Calback
                if (!response || response.errorMessage) {
                  // Error Callback
                  this.refreshDataFailureCallback(response);
                } else {
                  if (!!response.length) {
                    this.watch.updateCounter++;
                    this._store.dispatch('updateTeams', { items: response });
                    // TODO: Consider looping through user's teams, and pre-fetching room data for each team
                  } else {
                    this.refreshDataFailureCallback(response);
                  }
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                debugger;
                this.refreshDataFailureCallback(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function refreshData() {
        return _ref.apply(this, arguments);
      }

      return refreshData;
    }()
  }, {
    key: 'refreshDataFailureCallback',
    value: function refreshDataFailureCallback(response) {
      // Log exception in Google Analytics
      if (response && (response.length || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response).length)) {
        var exception = response.errorMessage || response;
        this.Vue.$ga.exception(exception);
      }

      // Log user out if request authorization fails
      if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
        this.Vue.$auth.logout().then(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].accessDenied);
      }
    }
  }, {
    key: 'getTeam',
    value: function getTeam(teamId) {
      var teams = this.teams.filter(function (team) {
        return team.teamId === teamId;
      });
      return !!teams.length ? teams.pop() : null;
    }
  }, {
    key: 'getPermalinksForTeam',
    value: function getPermalinksForTeam(teamId) {
      var _this3 = this;

      var options = {
        params: {
          teamId: teamId
        }
      };
      this.Vue.http.get(__WEBPACK_IMPORTED_MODULE_5__constants_roundsApiEndpoints__["f" /* API_ENDPOINT_SMARTSHEETS */], options).then(function (res) {
        return res.json();
      }).then(
      // Success Calback
      function (response) {
        // console.log("response", response);
        if (!response || response.errorMessage) {
          // Error Callback
          _this3.refreshDataFailureCallback(response);
        } else {
          _this3.permalinks = response;
        }
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._store.dispatch('clearCache');
    }
  }, {
    key: 'currentTeamId',
    get: function get() {
      return this.watch.currentTeamId;
    }
  }, {
    key: 'currentTeam',
    get: function get() {
      return this.watch.currentTeam;
    }
  }, {
    key: 'teams',
    get: function get() {
      return this._store.state.TeamsCache.teams;
    }
  }, {
    key: 'currentUserTeams',
    get: function get() {
      return this.watch.currentUserTeams;
    }
  }, {
    key: 'currentUserTeamIds',
    get: function get() {
      return this.watch.currentUserTeamIds;
    }
  }, {
    key: 'permalinks',
    get: function get() {
      return this.watch.permalinks;
    },
    set: function set(permalinks) {
      this.watch.permalinks = permalinks;
    }
  }]);

  return TeamService;
}();

var teamService = {
  install: function install(Vue, options) {
    var instance = new TeamService(Vue);
    Vue.prototype.$teamService = instance;
    Vue.$teamService = instance;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (teamService);

/***/ }),

/***/ "1ydg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "page--reset", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "headline" }, [
        _vm._v("Reset App Data")
      ]),
      _vm._v(" "),
      _c(
        "v-alert",
        { attrs: { value: true, color: "error", icon: "warning" } },
        [
          _c("p", [
            _c(
              "strong",
              { staticClass: "title", attrs: { "text-color": "error" } },
              [_vm._v("The buttons below should be used with extreme caution!")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "They will result in the permanent deletion of cached room data and unsynced reports, respectively."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { staticClass: "text-xs-center", attrs: { row: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn__reset_rooms",
                  attrs: { color: "error", disabled: _vm.resetRoomsDisabled },
                  on: {
                    click: function($event) {
                      return _vm.$roomService.reset()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("delete_forever")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [
                    _vm._v("Reset Rooms Cache")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btn__reset_reports",
                  attrs: { color: "error", disabled: _vm.resetSyncDisabled },
                  on: {
                    click: function($event) {
                      return _vm.$syncService.reset()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("delete_forever")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [
                    _vm._v("Delete Unsynced Reports")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6766c9cf", esExports)
  }
}

/***/ }),

/***/ "2tCf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hfL9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("931e0c96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-43c62aed\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StatusReports.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-43c62aed\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StatusReports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2wgF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KGL8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d09ebaf4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f1d4164\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Report.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f1d4164\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Report.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3Q7X":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMTEuNyA2MTIgNzY4LjYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAxMS43IDYxMiA3NjguNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cG9seWdvbiBmaWxsPSIjQjc5RkNDIiBwb2ludHM9IjAsMTEuNyAwLDcxLjUgNTIzLjgsNzgwLjMgNjEyLDc4MC4zIDYxMiw2MjMuNyAxNTYuNiwxMS43ICIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "3hdi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Campton-Bold.5cce0d5.ttf";

/***/ }),

/***/ "4+e1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Regular.d92211b.woff";

/***/ }),

/***/ "5ZXH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\ntd.column--room_report {\n  width: 96px;\n}\ntd.column--room_label {\n  min-width: 140px;\n}\ntd.column--org_unit {\n  min-width: 90px;\n  max-width: 250px;\n}\ntd.column--room_minimum_frequency {\n  min-width: 50px;\n}\ntd.column--room_last_checked {\n  min-width: 105px;\n}\ntd.column--room_check_count {\n  min-width: 50px;\n}\ntd.column--room_incident_count {\n  min-width: 70px;\n}\ndiv.flex {\n  max-width: 100%;\n}\n.top-container {\n  max-width: 600px;\n}\n.top-container--full {\n  max-width: 100%;\n}\n.flex-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.btn__download, .btn__my_rooms {\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow: auto;\n}\n@media (max-width: 959px) {\n.sm-pt-4 {\n    padding-top: 16px !important;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "5oIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamHome_vue__ = __webpack_require__("+A0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3ef1e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamHome_vue__ = __webpack_require__("iCXU");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b3ef1e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/TeamHome.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b3ef1e8", Component.options)
  } else {
    hotAPI.reload("data-v-0b3ef1e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "666/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c("h2", { staticClass: "page-title" }, [_vm._v("Admin")]),
    _vm._v(" "),
    _c("nav", [
      _c(
        "ul",
        { staticClass: "admin-page-links" },
        _vm._l(_vm.getPermalinks, function(permalink, name) {
          return _c(
            "li",
            { staticClass: "animate__animated animate__fadeIn" },
            [
              _c("a", { attrs: { href: permalink } }, [
                _vm._v(
                  "\n                Manage " +
                    _vm._s(name) +
                    "\n                "
                )
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fd8a062", esExports)
  }
}

/***/ }),

/***/ "6MKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "headline" }, [_vm._v("Login")]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [_c("router-link", { attrs: { to: "room" } }, [_vm._v("Room Picker")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}

/***/ }),

/***/ "6eCo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Bold.510bce2.ttf";

/***/ }),

/***/ "6s/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var GaTrackingCode =  false ? 'UA-111433639-1' : 'NO_TRACKING';
/* harmony default export */ __webpack_exports__["a"] = ({
  GA_TRACKING_CODE: GaTrackingCode
});

/***/ }),

/***/ "74BW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AkkuratPro-Bold.d9f993a.svg";

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "APaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_roundsApiEndpoints__ = __webpack_require__("toSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");






// Report Service Plugin

var ReportService = function () {
  function ReportService(Vue) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ReportService);

    this.Vue = Vue;
    this.watch = new Vue({
      data: function data() {
        return {
          reports: [],
          loading: true
        };
      }
    });

    // Fetch data on instantiation
    // this.refreshData();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ReportService, [{
    key: 'refreshData',
    value: function refreshData(teamId) {
      var _this = this;

      if (!!teamId) {
        teamId = this.Vue.$teamService.currentTeamId;
      }
      if (this.Vue.$auth.watch.authenticated && teamId) {
        this.loading = true;
        var options = {
          credentials: true,
          headers: {
            'Content-Type': 'application/json'
          },
          params: {
            teamId: teamId
          }
        };
        this.Vue.http.get(__WEBPACK_IMPORTED_MODULE_3__constants_roundsApiEndpoints__["g" /* API_ENDPOINT_STATUS_REPORTS */], options).then(function (res) {
          return res.json();
        }).then(
        // Success Calback
        function (response) {
          if (!response || response.errorMessage) {
            // Error Callback
            _this.refreshDataFailureCallback(response);
          } else {
            _this.reports = response;
            _this.loading = false;
          }
        },

        // Error Callback
        function (response) {
          _this.refreshDataFailureCallback(response);
        });
      }
    }
  }, {
    key: 'refreshDataFailureCallback',
    value: function refreshDataFailureCallback(response) {
      this.loading = false;

      // Log exception in Google Analytics
      if (response && (response.length || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response).length)) {
        var exception = response.errorMessage || response;
        this.Vue.$ga.exception(exception);
      }

      // Log user out if request authorization fails
      if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
        this.Vue.$auth.logout().then(__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].accessDenied);
      }
    }
  }, {
    key: 'reports',
    get: function get() {
      return this.watch.reports;
    },
    set: function set(reports) {
      this.watch.reports = reports;
    }
  }, {
    key: 'loading',
    get: function get() {
      return this.watch.loading;
    },
    set: function set(loading) {
      this.watch.loading = loading;
    }
  }]);

  return ReportService;
}();

var reportService = {
  install: function install(Vue, options) {
    var instance = new ReportService(Vue);
    Vue.prototype.$reportService = instance;
    Vue.$reportService = instance;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (reportService);

/***/ }),

/***/ "B0HW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Regular.cfc0f9e.eot";

/***/ }),

/***/ "CpV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_business_days__ = __webpack_require__("w4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_business_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_roundsApiEndpoints__ = __webpack_require__("toSf");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sync',
  data: function data() {
    return {
      teamUsage: {
        values: {
          startDate: null,
          endDate: null
        },
        reportUrl: '',
        startDateMenu: false,
        endDateMenu: false
      }
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    teamUsageInvalid: function teamUsageInvalid() {
      return this.teamUsage.values.startDate && this.teamUsage.values.endDate && __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default()(this.teamUsage.values.startDate, 'YYYY-MM-DD').startOf('day').format('x') > __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default()(this.teamUsage.values.endDate, 'YYYY-MM-DD').endOf('day').format('x');
    }
  },
  methods: {
    generateReportUrl: function generateReportUrl(reportId) {
      var base_url = __WEBPACK_IMPORTED_MODULE_5__constants_roundsApiEndpoints__["b" /* API_ENDPOINT_GENERATE_REPORT */];
      var query_string = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        teamId: this.teamId,
        reportId: reportId
      }, this[reportId].values)).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return !!value;
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        switch (key) {
          case 'startDate':
            value = __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default()(value, 'YYYY-MM-DD').startOf('day').format('x');
            break;
          case 'endDate':
            value = __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default()(value, 'YYYY-MM-DD').endOf('day').format('x');
            break;
        }
        return key + '=' + value;
      }).join('&');
      var report_url = base_url + '?' + query_string;
      return report_url;
    }
  }
});

/***/ }),

/***/ "EN1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("XLHc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766c9cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("1ydg");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pPfB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766c9cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Reset.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6766c9cf", Component.options)
  } else {
    hotAPI.reload("data-v-6766c9cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Exgt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMjkzIDI4MiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjkzIDI4MiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjE4Ni4xLDIuMSAxODYuMSwyMiAyMTkuNSwzMC40IDIyNi4xLDM4LjYgMjI2LjEsMTk4IDU5LjYsMSA1OC43LDAgOS41LDAgOS41LDE0LjkgMzYuOCw0NS41IA0KCTM2LjgsMjUyLjIgMCwyNjIuNSAwLDI3OS45IDEwNS41LDI3OS45IDEwNS41LDI2Mi40IDcyLjgsMjUzLjggNjYuMSwyNDUuNCA2Ni4xLDc5LjIgMjM2LjQsMjgyIDI1Ni4xLDI4MiAyNTYuMSwzMS40IDI5MywyMC4yIA0KCTI5MywyLjEgIi8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "FjuS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.page--generate_reports .btn--loader .btn__content {\n  opacity: 1;\n}\n.page--generate_reports .btn--loader .btn__content .icon {\n    opacity: 0;\n}\n.page--generate_reports .btn--loader .btn__loading {\n  width: 55px;\n}\n", ""]);

// exports


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: "RoomReady",
      showBrowserWarning: true,
      teamSelection: null
    };
  },
  mounted: function mounted() {
    this.$auth.isLoaded().then(this.redirectAfterAuth);
  },

  computed: {
    userTeams: function userTeams() {
      return this.$teamService.currentUserTeams.sort(function (a, b) {
        var k = 'teamName';
        return a[k] < b[k] ? -1 : 1;
      });
    },
    accessDenied: function accessDenied() {
      return Boolean(this.$route && this.$route.query && this.$route.query.goto);
    }
  },
  methods: {
    goToTeamHome: function goToTeamHome() {
      this.$router.push({
        name: 'TeamHome',
        params: {
          teamId: this.teamSelection
        }
      });
    },
    login: function login() {
      this.$auth.login();
      this.$auth.authWorkflowComplete().then(this.redirectAfterAuth);
    },
    logout: function logout() {
      this.$auth.logout();
    },
    redirectAfterAuth: function redirectAfterAuth() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$auth.watch.authenticated && _this.$route.query && _this.$route.query.goto) {
          _this.$router.push({ path: _this.$route.query.goto });
        } else if (_this.$auth.watch.authenticated && _this.$auth.user().teams.length < 2) {
          _this.$router.push({
            name: 'TeamHome',
            params: {
              teamId: _this.$auth.user().teams[0]
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "IOsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_roundsApiEndpoints__ = __webpack_require__("toSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");







// Room Service Plugin

var RoomService = function () {
  function RoomService(Vue) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RoomService);

    this.Vue = Vue;
    this._store = Vue.roomsStore;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RoomService, [{
    key: 'refreshData',
    value: function refreshData(teamId) {
      var _this = this;

      if (!teamId) {
        teamId = this.Vue.$teamService.currentTeamId;
      }
      if (this.Vue.$auth.watch.authenticated && !!teamId) {
        var options = {
          credentials: true,
          headers: {
            'Content-Type': 'application/json'
          },
          params: {
            teamId: teamId
          }
        };
        this.Vue.http.get(__WEBPACK_IMPORTED_MODULE_4__constants_roundsApiEndpoints__["e" /* API_ENDPOINT_ROOMS */], options).then(function (res) {
          return res.json();
        }).then(
        // Success Calback
        function (response) {
          if (!response || response.errorMessage) {
            // Error Callback
            _this.refreshDataFailureCallback(response);
          } else {
            _this._store.dispatch('updateRooms', { items: response.rooms, teamId: teamId });
            _this._store.dispatch('updateInventory', { items: response.inventory, teamId: teamId });
          }
        },

        // Error Callback
        function (response) {
          _this.refreshDataFailureCallback(response);
        });
      }
    }
  }, {
    key: 'refreshDataFailureCallback',
    value: function refreshDataFailureCallback(response) {
      // Log exception in Google Analytics
      if (response && (response.length || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response).length)) {
        var exception = response.errorMessage || response;
        this.Vue.$ga.exception(exception);
      }

      // Log user out if request authorization fails
      if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
        this.Vue.$auth.logout().then(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].accessDenied);
      }
    }
  }, {
    key: 'preCacheRoomsForCurrentUserTeams',
    value: function preCacheRoomsForCurrentUserTeams() {
      // Fetch data and cache rooms lists for current user's teams
      // TODO: Maybe check how long it's been since data was fetched and set a minimum refresh interval
      if (!!this.Vue.$teamService.currentUserTeamIds.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.Vue.$teamService.currentUserTeamIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var teamId = _step.value;

            this.refreshData(teamId);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: 'getRoom',
    value: function getRoom(roomId) {
      // TODO: Possibly fetch individual room from API
      var room = {};
      var roomsFiltered = this.rooms.filter(function (it) {
        return it.room_id === roomId;
      });
      if (roomsFiltered.length) {
        room = roomsFiltered.pop();
      }
      // TODO: Error if room not found
      return room;
    }
  }, {
    key: 'getRoomInventory',
    value: function getRoomInventory(roomId) {
      // TODO: Possibly fetch individual inventory from API
      var inventory = {};
      var inventoryFiltered = this.inventory.filter(function (it) {
        return it.room_id === roomId;
      });
      if (inventoryFiltered.length) {
        inventory = inventoryFiltered.pop().items.filter(function (it) {
          return it.inReport && it.inReport === 'Yes';
        });
      }
      // TODO: Error if room not found
      return inventory;
    }
  }, {
    key: 'getRoomInventoryForm',
    value: function getRoomInventoryForm(roomId) {
      var form = {};
      this.getRoomInventory(roomId).forEach(function (val) {
        form[val.featureId] = {
          status: null,
          issueDialog: false,
          issueHelp: false,
          issueDescription: ''
        };
      });
      return form;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._store.dispatch('clearCache');
    }
  }, {
    key: 'rooms',
    get: function get() {
      if (!!this.Vue.$teamService.currentTeamId && !!this._store.state.RoomsCache.rooms[this.Vue.$teamService.currentTeamId]) {
        return this._store.state.RoomsCache.rooms[this.Vue.$teamService.currentTeamId].filter(function (it) {
          return it.active_status === 'Yes';
        });
      }
      return [];
    }
  }, {
    key: 'inventory',
    get: function get() {
      if (!!this.Vue.$teamService.currentTeamId && !!this._store.state.RoomsCache.inventory[this.Vue.$teamService.currentTeamId]) {
        return this._store.state.RoomsCache.inventory[this.Vue.$teamService.currentTeamId];
      }
      return [];
    }
  }]);

  return RoomService;
}();

var roomService = {
  install: function install(Vue, options) {
    var instance = new RoomService(Vue);
    Vue.prototype.$roomService = instance;
    Vue.$roomService = instance;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (roomService);

/***/ }),

/***/ "KGL8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nli.px-0 > .list__tile {\n  padding: 0;\n}\n.table__report td {\n  width: 30px;\n}\n.table__report td:nth-child(2) {\n  width: auto;\n}\n.required-marker {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n.iframe__help {\n  border-width: 0;\n  border-style: none;\n}\nform .radio_group__feature_status .radio,\nform .radio_group__feature_status .radio .input-group__input {\n  max-width: 48px;\n}\nform .radio_group__feature_status > .input-group__input {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\nform\n  .radio_group__feature_status\n  > .input-group__input\n  .radio__feature_status__broken\n  > .input-group__input {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n}\nform\n  .radio_group__feature_status\n  > .input-group__input\n  .radio__feature_status__broken\n  > .input-group__input\n  .icon {\n  left: inherit;\n  right: 0;\n}\nform .radio_group__feature_status > .input-group__input label {\n  display: none;\n}\nform\n  .radio_group__feature_status\n  > .input-group__input\n  .radio__feature_status__broken\n  > .input-group__input\n  .input-group--selection-controls__ripple {\n  -webkit-transform: translate3d(9px, -50%, 0);\n  transform: translate3d(9px, -50%, 0);\n}\n", ""]);

// exports


/***/ }),

/***/ "KKHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_business_days__ = __webpack_require__("w4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_business_days__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RoomPicker',
  data: function data() {
    return {
      campusAndRegionSelection: null,
      buildingSelection: null,
      roomSelection: null,
      campusLabels: {
        CHC: "Chicago",
        EVA: "Evanston",
        SFO: "San Francisco",
        QTR: "Qatar"
      }
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    startReport: function startReport() {
      var roomId = this.roomSelection;
      var teamId = this.teamId;
      this.$router.push({
        path: '/' + teamId + '/report/' + roomId
      });
    },
    resetForm: function resetForm() {
      this.campusAndRegionSelection = this.buildingSelection = this.roomSelection = null;
    },
    loadData: function loadData() {
      this.$roomService.refreshData(this.teamId);
    },
    sortRoomsBySLA: function sortRoomsBySLA(a, b) {
      // TODO: Consider moving this sort to RoomService
      a.last_checked = a.last_checked ? a.last_checked : 0;
      b.last_checked = b.last_checked ? b.last_checked : 0;

      a.minimum_frequency = a.minimum_frequency ? a.minimum_frequency : 90;
      b.minimum_frequency = b.minimum_frequency ? b.minimum_frequency : 90;

      var a_next_check_due = a.last_checked > 0 ? __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(a.last_checked, 'x').businessAdd(a.minimum_frequency).format('X') : __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(0, 'X').format('X');
      var b_next_check_due = b.last_checked > 0 ? __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(b.last_checked, 'x').businessAdd(b.minimum_frequency).format('X') : __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(0, 'X').format('X');

      if (a_next_check_due > b_next_check_due) {
        // B first
        return 1;
      }
      if (a_next_check_due < b_next_check_due) {
        // A first
        return -1;
      }
      return 0;
    },
    sortRoomsByLastChecked: function sortRoomsByLastChecked(a, b) {
      // TODO: Consider moving this sort to RoomService
      a.last_checked = a.last_checked ? a.last_checked : 0;
      b.last_checked = b.last_checked ? b.last_checked : 0;

      if (a.last_checked < b.last_checked) {
        // A first
        return 1;
      }
      if (a.last_checked > b.last_checked) {
        // B first
        return -1;
      }
      return 0;
    }
  },
  computed: {
    roomsLoading: function roomsLoading() {
      return !this.$roomService.rooms.length;
    },
    campusSelection: function campusSelection() {
      if (this.campusAndRegionSelection) {
        return this.campusAndRegionSelection.campus_id;
      }
      return null;
    },
    campusRegionSelection: function campusRegionSelection() {
      if (this.campusAndRegionSelection) {
        return this.campusAndRegionSelection.campus_region_id;
      }
      return null;
    },
    campuses: function campuses() {
      var _this = this;

      var rooms = this.$roomService.rooms;
      var campuses = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.map(function (it) {
        var campus = {
          campus_id: it.campus,
          campus_region: it.campus,
          campus_region_id: null,
          label: _this.campusLabels[it.campus] || it.campus
        };
        if (it.campus_region) {
          campus.campus_region_id = it.campus_region;
          campus.label += ' (' + it.campus_region + ')';
          campus.campus_region = it.campus + '_' + it.campus_region;
        }
        return campus;
      }).filter(function (it, idx, arr) {
        return arr.map(function (mapObj) {
          return mapObj.campus_region;
        }).indexOf(it.campus_region) === idx;
      }))).sort();
      return campuses;
    },
    buildings: function buildings() {
      var _this2 = this;

      var rooms = this.$roomService.rooms;
      if (this.campusSelection) {
        rooms = rooms.filter(function (room) {
          return room.campus === _this2.campusSelection;
        });
      }
      if (this.campusRegionSelection) {
        rooms = rooms.filter(function (room) {
          return room.campus_region === _this2.campusRegionSelection;
        });
      }
      var buildings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.map(function (it) {
        return it.building;
      }))).sort();
      return buildings;
    },
    rooms: function rooms() {
      var _this3 = this;

      var rooms = this.$roomService.rooms;
      if (this.buildingSelection) {
        rooms = rooms.filter(function (room) {
          return room.building === _this3.buildingSelection;
        });
      }
      if (this.campusSelection) {
        rooms = rooms.filter(function (room) {
          return room.campus === _this3.campusSelection;
        });
      }
      if (this.campusRegionSelection) {
        rooms = rooms.filter(function (room) {
          return room.campus_region === _this3.campusRegionSelection;
        });
      }
      rooms = rooms.map(function (room) {
        var timeAgo = room.last_checked ? __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(room.last_checked, 'x').fromNow() : 'Never';
        // room.selectLabel = '<span class="room-list-label">' + room.label + '</span> <small class="room-list-last-checked caption"><em>Checked: ' + timeAgo + '</em></small>';
        room.selectLabel = room.label + ' (Checked: ' + timeAgo + ')';
        return room;
      }).sort(this.sortRoomsBySLA);
      return rooms;
    },
    recentlyCheckedRooms: function recentlyCheckedRooms() {
      return this.$roomService.rooms.sort(this.sortRoomsByLastChecked).splice(0, 10).map(function (room) {
        room.last_checked_time_ago = room.last_checked ? __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(room.last_checked, 'x').fromNow() : 'Never';
        return room;
      });
    }
  },
  watch: {
    campusSelection: function campusSelection(newValue, oldVal) {
      this.buildingSelection = this.roomSelection = null;
    },
    campusRegionSelection: function campusRegionSelection(newValue, oldVal) {
      this.buildingSelection = this.roomSelection = null;
    },
    buildingSelection: function buildingSelection(newValue, oldVal) {
      this.roomSelection = null;
    }
  }
});

/***/ }),

/***/ "KS52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    props: {
        teamId: {
            type: String,
            required: true
        }
    },
    mounted: function mounted() {
        this.$teamService.getPermalinksForTeam(this.teamId);
    },

    computed: {
        getPermalinks: function getPermalinks() {
            return this.$teamService.permalinks;
        }
    }

});

/***/ }),

/***/ "LLoF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nli.px-0 > .list__tile {\n  padding: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "Lsme":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Regular.4324062.woff2";

/***/ }),

/***/ "LvpE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Campton-Bold.1a5370b.eot";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ty93");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("RTaz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mi0r":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FjuS");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("15cf78dd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1350a8ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GenerateReports.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1350a8ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GenerateReports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "MsbD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA5LjUgMTcuOCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgOS41IDE3LjgiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTgsMEgxLjVDMC43LDAsMCwwLjcsMCwxLjV2MTQuOGMwLDAuOCwwLjcsMS41LDEuNSwxLjVIOGMwLjgsMCwxLjUtMC43LDEuNS0xLjVWMS41QzkuNSwwLjcsOC45LDAsOCwweg0KCSBNMy45LDEuMmgxLjhDNS44LDEuMiw2LDEuMyw2LDEuNWMwLDAuMi0wLjEsMC4zLTAuMywwLjNIMy45Yy0wLjIsMC0wLjMtMC4xLTAuMy0wLjNDMy42LDEuMywzLjcsMS4yLDMuOSwxLjJ6IE00LjgsMTcuMg0KCWMtMC41LDAtMC45LTAuNC0wLjktMC45YzAtMC41LDAuNC0wLjksMC45LTAuOWMwLjUsMCwwLjksMC40LDAuOSwwLjlDNS43LDE2LjgsNS4zLDE3LjIsNC44LDE3LjJ6IE04LjksMTQuOEgwLjZWM2g4LjNWMTQuOHoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "NFBx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__("AHhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_integrations__ = __webpack_require__("M6om");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_GoogleAnalyticsConfig_js__ = __webpack_require__("6s/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FlashMessage_vue__ = __webpack_require__("xUkt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_EventService__ = __webpack_require__("0Act");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_Store__ = __webpack_require__("fBFr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_TeamService__ = __webpack_require__("1fe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_SyncService__ = __webpack_require__("aMSo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_RoomService__ = __webpack_require__("IOsC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_ReportService__ = __webpack_require__("APaH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// Sentry.io



var ENV = "development".trim();
var monitoredEnvs = ['main', 'development'];
if (monitoredEnvs.includes(ENV)) {
  console.debug('Sentry monitoring: ' + ENV);
  __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["a" /* init */]({
    dsn: 'https://67d7be728a594fd3a284bd942369f2a3@sentry.io/2640365',
    integrations: [new __WEBPACK_IMPORTED_MODULE_2__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], attachProps: true })],
    environment: ENV
  });
} else {
  console.debug('Skipping sentry.io for env: ' + ENV);
}

// Cookie

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookies___default.a);

// Router


// Google Analytics


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: __WEBPACK_IMPORTED_MODULE_6__constants_GoogleAnalyticsConfig_js__["a" /* default */].GA_TRACKING_CODE,
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
});

// Flash message

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('flash-message', __WEBPACK_IMPORTED_MODULE_7__components_FlashMessage_vue__["a" /* default */]);

// Vuetify

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a);
__webpack_require__("7zck");
__webpack_require__("s6ZO");
__webpack_require__("NFBx");



// Cookie

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_resource__["a" /* default */]);

// include credentials with requests.
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  request.headers['Content-Type'] = 'application/json';
  request.credentials = true;
  next();
});

// Events Service (global Vue instance for emitting events)

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__services_EventService__["a" /* default */]);

// Sync Store

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__store_Store__["a" /* default */]);

// Room Service

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__services_TeamService__["a" /* default */]);

// Sync Service

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__services_SyncService__["a" /* default */]);

// Room Service

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__services_RoomService__["a" /* default */]);

// Report Service

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__services_ReportService__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.mainTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
});

/***/ }),

/***/ "Nw4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "page--status_reports" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Status Reports (Weekly)")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [
            _c("em", [_vm._v(_vm._s(_vm.lastChecked))])
          ]),
          _vm._v(" "),
          !!_vm.$roomService.rooms
            ? _c(
                "v-layout",
                { staticClass: "status_reports mt-4" },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "top-container top-container--full",
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "justify-space-around": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    lg4: "",
                                    md4: "",
                                    sm12: "",
                                    xs12: ""
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Rooms",
                                      "single-line": "",
                                      "hide-details": "",
                                      loading: _vm.$reportService.loading
                                    },
                                    model: {
                                      value: _vm.rawSearchTerms,
                                      callback: function($$v) {
                                        _vm.rawSearchTerms = $$v
                                      },
                                      expression: "rawSearchTerms"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showDepartmentUnit
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        lg4: "",
                                        md4: "",
                                        sm12: "",
                                        xs12: ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        staticClass: "select__room_org_units",
                                        attrs: {
                                          items: _vm.roomOrgUnits,
                                          "item-text": "label",
                                          "item-value": "value",
                                          label: "Department / Unit",
                                          loading: _vm.$reportService.loading,
                                          autocomplete: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.filter.roomOrgUnit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filter,
                                              "roomOrgUnit",
                                              $$v
                                            )
                                          },
                                          expression: "filter.roomOrgUnit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    lg4: "",
                                    md4: "",
                                    sm12: "",
                                    xs12: ""
                                  }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "select__room_owners",
                                    attrs: {
                                      items: _vm.roomOwners,
                                      "item-text": "label",
                                      "item-value": "value",
                                      label: "Owner",
                                      loading: _vm.$reportService.loading,
                                      autocomplete: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.roomOwner,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "roomOwner", $$v)
                                      },
                                      expression: "filter.roomOwner"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: { lg6: "", md6: "", sm6: "", xs12: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      label: "Only Show Overdue Rooms",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.filter.onlyOverdue,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "onlyOverdue", $$v)
                                      },
                                      expression: "filter.onlyOverdue"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.viewerIsRoomOwner
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-sm-right text-xs-center",
                                      attrs: {
                                        lg6: "",
                                        md6: "",
                                        sm6: "",
                                        xs12: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn__my_rooms",
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.filter.roomOwner = _vm.$auth.user().uid
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "btn__text" },
                                            [_vm._v("Show My Rooms")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        attrs: {
                          search: _vm.filter.searchTerms,
                          headers: _vm.reportsTableHeaders,
                          items: _vm.reportsTableItems,
                          pagination: _vm.pagination,
                          "custom-filter": _vm.customSearchFilter,
                          loading: _vm.$reportService.loading,
                          "item-key": "room_id",
                          "must-sort": "",
                          "hide-actions": "",
                          "no-results-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available.",
                          "no-data-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available."
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.pagination = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "headers",
                              fn: function(props) {
                                return [
                                  _c(
                                    "tr",
                                    { staticClass: "primary" },
                                    [
                                      _vm._l(props.headers, function(header) {
                                        return [
                                          !header.hide
                                            ? _c(
                                                "th",
                                                {
                                                  key: header.text,
                                                  class: [
                                                    header.sortable ||
                                                    header.align !== "left"
                                                      ? "px-1"
                                                      : "pr-1",
                                                    "white--text",
                                                    "text-xs-" +
                                                      (header.align
                                                        ? header.align
                                                        : "center"),
                                                    "column",
                                                    header.isWeekHeader
                                                      ? "column--room_status"
                                                      : "",
                                                    "column--" + header.value,
                                                    header.value ===
                                                    _vm.pagination.sortBy
                                                      ? "active"
                                                      : "",
                                                    header.sortable !== false
                                                      ? "sortable"
                                                      : "",
                                                    _vm.pagination.descending
                                                      ? "desc"
                                                      : "asc"
                                                  ],
                                                  attrs: {
                                                    role: "columnheader",
                                                    "aria-label": header.text,
                                                    "aria-sort": header.sortable
                                                      ? "sortable"
                                                      : ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.changeSort(
                                                        header
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  header.sortable !== false
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [_vm._v("arrow_upward")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(header.text) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              }
                            },
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_report px-1 text-xs-center"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: "",
                                                    disabled:
                                                      _vm.roomReportDialog
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openRoomReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("assignment")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.startReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [_vm._v("edit")])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_label pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.label) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showDepartmentUnit
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-xs-left column--org_unit pr-1"
                                        },
                                        [
                                          !!props.item.org_unit.line1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line1
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !!props.item.org_unit.line2
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line2
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus_region pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus_region) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: [
                                        "text-xs-right",
                                        "column--room_minimum_frequency",
                                        "px-1",
                                        props.item.check_status_color_class
                                      ]
                                    },
                                    [
                                      !!props.item.support_level
                                        ? _c(
                                            "v-tooltip",
                                            { attrs: { right: "" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item
                                                        .minimum_frequency
                                                    ) + " Days"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.support_level
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.minimum_frequency
                                              ) + " Days"
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_last_checked pr-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            props.item.last_checked
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.weeks, function(week, index) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          key: index,
                                          staticClass:
                                            "text-xs-center px-1 column--room_status"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.getStatusIcon(
                                                  props.item[
                                                    "room_status_" + week
                                                  ]
                                                ).color
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStatusIcon(
                                                    props.item[
                                                      "room_status_" + week
                                                    ]
                                                  ).icon
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          45372355
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            persistent: "",
                            scrollable: "",
                            "max-width": "90%",
                            "content-class": "dialog--room_status_reports"
                          },
                          model: {
                            value: _vm.roomReportDialog,
                            callback: function($$v) {
                              _vm.roomReportDialog = $$v
                            },
                            expression: "roomReportDialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-toolbar",
                                { attrs: { dark: "", color: "primary" } },
                                [
                                  _c("v-toolbar-title", [
                                    _vm._v(_vm._s(_vm.roomReportLabel))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", dark: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.closeRoomReport()
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.roomReportTableHeaders,
                                  items: _vm.roomReportTableItems,
                                  loading: _vm.$reportService.loading,
                                  "item-key": "report_id",
                                  "hide-actions": "",
                                  "no-results-text":
                                    "No reports are available for this room.",
                                  "no-data-text":
                                    "No reports are available for this room."
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-center column--room_status"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.getStatusIcon(
                                                      props.item.room_status
                                                    ).color
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStatusIcon(
                                                        props.item.room_status
                                                      ).icon
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--date"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    props.item.timestamp
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--notes"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "feature_bullet_list"
                                                },
                                                [
                                                  _vm._l(
                                                    props.item.inventory,
                                                    function(feature, index) {
                                                      return [
                                                        _c(
                                                          "li",
                                                          {
                                                            key: index,
                                                            class:
                                                              "feature_bullet_list_item feature_bullet_list_item--" +
                                                              _vm.getStatusIcon(
                                                                props.item[
                                                                  feature
                                                                    .featureId
                                                                ]
                                                              ).color
                                                          },
                                                          [
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "feature_bullet__name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      feature.featureName
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            props.item[
                                                              feature.featureId +
                                                                "_issue_description"
                                                            ]
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "feature_bullet__notes"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          props
                                                                            .item[
                                                                            feature.featureId +
                                                                              "_issue_description"
                                                                          ]
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1764027880
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c62aed", esExports)
  }
}

/***/ }),

/***/ "PKE/":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@charset \"UTF-8\";\n/*Font Declarations*/\n@font-face {\n  font-family: 'Camptons';\n  src: url(" + escape(__webpack_require__("LvpE")) + ");\n  src: url(" + escape(__webpack_require__("LvpE")) + "?#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__("zHxG")) + ") format(\"woff2\"), url(" + escape(__webpack_require__("zaAj")) + ") format(\"woff\"), url(" + escape(__webpack_require__("3hdi")) + ") format(\"truetype\"), url(" + escape(__webpack_require__("rVG2")) + "#Campton-Bold) format(\"svg\");\n  font-weight: bold;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Akkurat Bold';\n  src: url(" + escape(__webpack_require__("cydc")) + ");\n  src: url(" + escape(__webpack_require__("cydc")) + "?#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__("+oK5")) + ") format(\"woff2\"), url(" + escape(__webpack_require__("REYW")) + ") format(\"woff\"), url(" + escape(__webpack_require__("6eCo")) + ") format(\"truetype\"), url(" + escape(__webpack_require__("74BW")) + "#AkkuratPro-Bold) format(\"svg\");\n  font-weight: bold;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Akkurat';\n  src: url(" + escape(__webpack_require__("B0HW")) + ");\n  src: url(" + escape(__webpack_require__("B0HW")) + "?#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__("Lsme")) + ") format(\"woff2\"), url(" + escape(__webpack_require__("4+e1")) + ") format(\"woff\"), url(" + escape(__webpack_require__("uf1r")) + ") format(\"truetype\"), url(" + escape(__webpack_require__("m6y1")) + "#AkkuratPro-Regular) format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*Color Variables*/\nfooter {\n  background: #4e2a84;\n  color: white;\n  font: 14px/1.3em 'Akkurat';\n  padding: 3rem 0;\n  width: 100%;\n}\nfooter a {\n    font-family: 'Akkurat';\n    color: white !important;\n    text-decoration: underline;\n}\nfooter a:hover {\n      text-decoration: none;\n}\nfooter .contain-970 {\n    max-width: 970px;\n    margin: auto;\n}\n.footer-content {\n  margin-right: 5.15464%;\n  display: inline-block;\n  position: relative;\n  vertical-align: top;\n}\n.footer-content ul {\n    list-style-type: none;\n    padding-left: 0;\n}\n.footer-content ul li {\n      padding-bottom: 0.8rem;\n}\n.footer-content:nth-of-type(1) {\n    width: 23.71134%;\n}\n.footer-content:nth-of-type(1) img:not(.png) {\n      width: 100%;\n}\n.footer-content:nth-of-type(2) {\n    width: 25.7732%;\n}\n.footer-content:nth-of-type(3) {\n    width: 18.04124%;\n}\n.footer-content:nth-of-type(4) {\n    width: 14.43299%;\n    margin-right: 0;\n}\n.footer-content p {\n    margin-top: 0;\n}\n.footer-content strong {\n    font-family: \"Akkurat Bold\" !important;\n    font-weight: normal;\n}\n.footer-content .footer-icon {\n    height: 29px;\n    width: 18px;\n    left: -25px;\n    margin-top: 0.5em;\n}\n.footer-content img {\n    margin-bottom: 1rem;\n    max-width: 170px;\n}\n.footer-content.contact ul {\n    margin: 0 0 1rem 2rem;\n    position: relative;\n}\n.footer-content.contact ul:nth-of-type(3) {\n      margin-bottom: 0;\n}\n.footer-content.contact ul li .hide-label {\n      position: absolute;\n      left: -10000px;\n      top: auto;\n      width: 1px;\n      height: 1px;\n      overflow: hidden;\n}\n.footer-content.contact ul li.footer-pin-icon {\n      background: url(" + escape(__webpack_require__("1elP")) + ") no-repeat;\n      background-size: 18px 24px;\n      position: absolute;\n      top: 2px;\n      left: -2rem;\n      height: 24px;\n      width: 18px;\n}\n.footer-content.contact ul li.footer-phone-icon {\n      background: url(" + escape(__webpack_require__("MsbD")) + ") no-repeat;\n      background-size: 18px 24px;\n      position: absolute;\n      top: 2px;\n      left: -2rem;\n      height: 24px;\n      width: 18px;\n}\n.footer-content.contact ul li.footer-email-icon {\n      background: url(" + escape(__webpack_require__("0w89")) + ") no-repeat;\n      background-size: 18px 24px;\n      position: absolute;\n      top: 2px;\n      left: -2.2rem;\n      height: 24px;\n      width: 18px;\n}\n.social {\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n  margin: 4px;\n  width: 39px;\n  height: 39px;\n  font-size: 0;\n  text-indent: -9999px;\n  background: url(" + escape(__webpack_require__("oBIz")) + ");\n  background-color: #fff;\n  -webkit-transition: background 0.3s;\n  transition: background 0.3s;\n  border: 1px solid white;\n}\n.facebook {\n  background-position: 0 0;\n}\n.facebook:hover {\n    background-position: 0 -39px;\n}\n.twitter {\n  background-position: -39px 0;\n}\n.twitter:hover {\n    background-position: -39px -39px;\n}\n.instagram {\n  background-position: -78px 0;\n}\n.instagram:hover {\n    background-position: -78px -39px;\n}\n.rss {\n  background-position: -117px 0;\n}\n.rss:hover {\n    background-position: -117px -39px;\n}\n.youtube {\n  background-position: -156px 0;\n}\n.youtube:hover {\n    background-position: -156px -39px;\n}\n.tumblr {\n  background-position: -195px 0;\n}\n.tumblr:hover {\n    background-position: -195px -39px;\n}\n.wordpress {\n  background-position: -234px 0;\n}\n.wordpress:hover {\n    background-position: -234px -39px;\n}\n.futurity {\n  background-position: -273px 0;\n}\n.futurity:hover {\n    background-position: -273px -39px;\n}\n.vimeo {\n  background-position: -312px 0;\n}\n.vimeo:hover {\n    background-position: -312px -39px;\n}\n.linkedin {\n  background-position: -351px 0;\n}\n.linkedin:hover {\n    background-position: -351px -39px;\n}\n.google-plus {\n  background-position: -390px 0;\n}\n.google-plus:hover {\n    background-position: -390px -39px;\n}\n.google-groups {\n  background-position: -429px 0;\n}\n.google-groups:hover {\n    background-position: -429px -39px;\n}\n.blog {\n  background-position: -468px 0;\n}\n.blog:hover {\n    background-position: -468px -39px;\n}\n.github {\n  background-position: -507px 0;\n}\n.github:hover {\n    background-position: -507px -39px;\n}\n.flickr {\n  background-position: -546px 0;\n}\n.flickr:hover {\n    background-position: -546px -39px;\n}\n.storify {\n  background-position: -585px 0;\n}\n.storify:hover {\n    background-position: -585px -39px;\n}\n.pinterest {\n  background-position: -624px 0;\n}\n.pinterest:hover {\n    background-position: -624px -39px;\n}\n.we-will {\n  background-position: -663px 0;\n}\n.we-will:hover {\n    background-position: -663px -39px;\n}\n@media screen and (max-width: 1140px) {\nfooter {\n    padding: 3rem 1rem;\n}\n}\n@media screen and (max-width: 870px) {\n.footer-content {\n    margin-bottom: 1.5rem;\n}\n.footer-content:nth-of-type(1), .footer-content:nth-of-type(3) {\n      width: 45%;\n      margin-right: 5%;\n}\n.footer-content:nth-of-type(2), .footer-content:nth-of-type(4) {\n      width: 46%;\n      margin-right: 0;\n}\n}\n@media screen and (max-width: 550px) {\n.footer-content:nth-of-type(1), .footer-content:nth-of-type(2), .footer-content:nth-of-type(3), .footer-content:nth-of-type(4) {\n    width: 100%;\n    margin-right: 0;\n}\n}\n\n/* Loading Progress Bar */\nhtml #app-content {\n  opacity: 1;\n  -webkit-transition: opacity .2s ease;\n  transition: opacity .2s ease;\n}\nhtml #app-content > .card {\n    width: 100%;\n}\nhtml.nprogress-busy #app-content {\n  opacity: .5;\n  -webkit-transition: opacity .1s ease;\n  transition: opacity .1s ease;\n}\nhtml #nprogress .bar {\n  background: white;\n}\nhtml #nprogress .bar .peg {\n    -webkit-box-shadow: 0 0 10px white, 0 0 5px white;\n            box-shadow: 0 0 10px white, 0 0 5px white;\n}\n#roomready-version {\n  display: block;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  font-size: 11px;\n  font-weight: bold;\n  color: #444;\n  background: #fff;\n  border: 1px solid #CCCCCC;\n  border-bottom: 0;\n  border-left: 0;\n  opacity: .75;\n}\n#roomready-version em {\n    padding: 6px;\n}\n\n/* Style btn inner to make sure height matches parent */\n.btn__content {\n  height: inherit;\n}\n.flex-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n/*Text Selection Enhancement*/\n::selection {\n  background: #d2c2eb;\n  /* WebKit/Blink Browsers */\n  color: inherit;\n}\n::-moz-selection {\n  background: #d2c2eb;\n  /* Gecko Browsers */\n  color: inherit;\n}\n.content-500 {\n  max-width: 700px;\n  margin: auto;\n  padding: 5px 20px;\n  padding-bottom: 0px;\n  font-size: 16px;\n}\n.application {\n  background-color: white;\n}\n.applogo {\n  margin: 0px;\n  font-size: 21px;\n  color: white;\n  text-transform: uppercase;\n}\n.applogo.nulogo {\n    width: 170px;\n    height: 51px;\n    overflow: hidden;\n    text-indent: -9999em;\n    background-image: url(" + escape(__webpack_require__("QZBX")) + ");\n    background-position: center;\n    background-repeat: no-repeat;\n}\n.applogo--with-teamname {\n    float: left;\n    line-height: 1;\n}\n.applogo--with-teamname:after {\n      content: \"\";\n      display: inline-block;\n      height: 23px;\n      margin-bottom: -4px;\n      padding-right: 7px;\n      margin-right: 9px;\n      border-right: 2px solid white;\n}\n.applogo + .teamname {\n    margin: 0px;\n    font-size: 16px;\n    line-height: 1;\n    text-transform: uppercase;\n}\n@media all and (max-width: 650px) {\n.applogo--with-teamname {\n      display: none;\n}\n.applogo + .teamname {\n      padding: 10px;\n      font-size: 14px;\n}\n}\n\n/* Mobile Style For Toolbar Logos */\n.alert {\n  margin: 30px;\n  background-color: rgba(239, 85, 63, 0.7);\n  color: white;\n  border: none !important;\n}\n.alert .icon {\n    color: white !important;\n}\n.alert strong {\n    color: white;\n}\n.flex.unauthenticated {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  background-image: url(" + escape(__webpack_require__("VTGo")) + ");\n  background-size: cover;\n}\n.flex.unauthenticated .card {\n    background-color: transparent !important;\n}\n.hero-wrapper {\n  margin: 100px 10px;\n}\n.hero {\n  font-size: 24px;\n  font-family: \"Camptons\";\n  color: #fff;\n  text-shadow: 2px 2px 0px #000;\n}\n.hero.small-text:before {\n    background: url(" + escape(__webpack_require__("3Q7X")) + ") no-repeat 50%/17px 21px;\n    padding: 0 1.5rem;\n    content: \" \";\n}\n.hero.small-text:after {\n    background: url(" + escape(__webpack_require__("3Q7X")) + ") no-repeat 50%/17px 21px;\n    padding: 0 2rem;\n    content: \" \";\n}\n.hero.large-text {\n    font-size: 48px;\n}\n.custom-button {\n  padding-left: 40px;\n}\n.custom-button.netid {\n    background-image: url(" + escape(__webpack_require__("Exgt")) + ");\n    overflow: hidden;\n    font-family: \"Akkurat Bold\" !important;\n}\nh2.page-title {\n  line-height: 1.2;\n  font-family: \"Camptons\";\n  color: #4E2A84;\n  text-align: center;\n  font-size: 36px;\n  margin: 10px auto 20px auto;\n}\n@media screen and (max-width: 600px) {\nh2.page-title {\n      font-size: 28px;\n}\n}\n@media screen and (max-width: 450px) {\nh2.page-title {\n      font-size: 21px;\n}\n}\n.instructions-page ol li {\n  margin-bottom: 5px;\n}\n.instructions-page .reminders {\n  padding: 10px;\n  color: #716C6B;\n  font-size: 14px;\n  line-height: 1.2;\n  font-style: italic;\n}\n.instructions-page .reminders p {\n    margin-bottom: 5px;\n}\n.roompicker-page .picker-form {\n  max-width: 500px;\n  margin: auto;\n}\n.roompicker-page .recent_room_checks {\n  max-width: 500px;\n  margin: auto;\n  background-color: #f0f0f0;\n  padding: 10px;\n}\n.roompicker-page .recent_room_checks .title {\n    text-align: center;\n    color: #716C6B;\n}\n.roompicker-page .recent_room_checks .table {\n    background-color: transparent;\n    color: #716C6B;\n}\n.roompicker-page .recent_room_checks .table thead th {\n      font-style: italic;\n}\n.report-page .table .help-btn {\n  font-size: 18px;\n  color: #CCCCCC;\n}\n.report-page .table .resource-name {\n  display: block;\n  font-size: 14px;\n  line-height: 1.2em;\n}\n.report-page .table .resource-description {\n  display: block;\n  font-size: 14px;\n  line-height: 1.2em;\n  color: #716C6B;\n}\n.report-page .table thead th strong {\n  font-weight: normal;\n}\n.page--reset .alert.error p {\n  color: #fff;\n}\n.dialog--room_status_reports .table__overflow {\n  overflow-y: auto;\n}\n.dialog--room_status_reports table tbody tr td {\n  vertical-align: top;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n.dialog--room_status_reports .feature_bullet_list {\n  list-style: none;\n  padding: 0;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item {\n    position: relative;\n    margin: 5px 0;\n    padding-left: 1.4em;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item:first-child {\n      margin-top: 0;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item:last-child {\n      margin-bottom: 0;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item:before {\n      content: \"\\2022   \";\n      font-size: 22px;\n      line-height: 16px;\n      position: absolute;\n      left: 0;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item.feature_bullet_list_item--success:before {\n      color: #4E2A84;\n}\n.dialog--room_status_reports .feature_bullet_list .feature_bullet_list_item.feature_bullet_list_item--warning:before {\n      color: #FFC520;\n}\n.card p {\n  color: #716C6B;\n}\n.required-marker {\n  font-size: 18px;\n  top: 0px !important;\n  right: 4px !important;\n  left: auto !important;\n  opacity: 1 !important;\n}\n\n/* Style updates */\n.success,\n.btn__start_report,\n.text-xs-center.my-4 .success {\n  background-color: #4E2A84 !important;\n  border-color: #4E2A84 !important;\n  color: #ffffff !important;\n}\n.error--text {\n  color: #4E2A84 !important;\n}\n.btn.btn--disabled {\n  border-radius: 4px;\n}\n.report-page form .help-btn,\n.report-page form .btn__content .icon.help-btn,\n.report-page form .grey--text .icon.material-icons {\n  color: #4E2A84;\n}\n.report-page .table thead th strong {\n  font-weight: 700;\n  color: #4E2A84;\n}\n.text-xs-center .btn__reset_form .btn__content {\n  border-radius: 4px;\n  border: 1px solid #999;\n  color: #999;\n  background: #fff;\n  height: inherit;\n}\n.text-xs-center .btn__reset_form:hover .btn__content {\n  background: #ccc;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n.instructions-page h2 {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.instructions-page .error--text .btn__content {\n  border: 1px solid #999;\n  height: inherit;\n}\n.instructions-page .error--text .btn__content:hover {\n  border: 1px solid #ccc;\n  background: #ccc;\n}\n.instructions-page .error--text .btn__content:hover .btn__text,\n.instructions-page .error--text .btn__content:hover .icon {\n  color: #fff;\n}\n.instructions-page .error--text .btn__text,\n.instructions-page .error--text .icon {\n  color: #999;\n}\n.application--light .toolbar {\n  background-color: #4E2A84 !important;\n  color: white !important;\n}\n.dialog--active .btn .btn__content .icon {\n  color: #ffffff;\n}\n.dialog--active .btn--active .btn__content:before,\n.dialog--active .btn:hover .btn__content:before,\n.dialog--active .btn:focus .btn__content:before {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n.dialog--active.dialog--persistent {\n  z-index: 99999;\n}\nbutton.btn.btn--icon.btn--raised.btn--right {\n  margin-right: 0;\n}\n.card__actions button .btn__content {\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #999;\n  min-width: 162px;\n  padding: 0;\n  height: inherit;\n}\n.card__actions button.grey--text:hover .btn__content {\n  background: #ccc;\n  border: 1px solid #ccc;\n}\n.card__actions button.grey--text:hover .btn__content .icon,\n.card__actions button.grey--text:hover .btn__content .btn__text {\n  color: #ffffff;\n}\n.card__actions button.grey--text .btn__content .icon {\n  color: #999999;\n}\n.card__actions button.primary--text .btn__content {\n  background: #4E2A84;\n  border: 1px solid #4E2A84;\n}\n.card__actions button.primary--text:hover .btn__content {\n  background: #5b3c8c;\n  border: 1px solid #5b3c8c;\n}\n.card__actions button.primary--text .icon--left {\n  margin-right: 10px;\n}\n.card__actions button.primary--text .btn__content span.btn__text {\n  color: #ffffff;\n}\n.input-group {\n  padding-top: 0 !important;\n}\n.input-group--text-field label {\n  top: 0 !important;\n}\n.roompicker-page .recent_room_checks {\n  border-radius: 6px;\n  background-color: rgba(225, 221, 236, 0.5) !important;\n}\n.roompicker-page .recent_room_checks .title {\n  text-align: center;\n  font-family: Camptons;\n  color: #4e2a84;\n  font-size: 28px !important;\n  letter-spacing: 0 !important;\n  margin: 12px 0 0;\n}\n.roompicker-page .recent_room_checks .table thead th {\n  font-weight: 700;\n  color: #333;\n  font-size: 0.9em !important;\n  font-style: unset;\n}\n.table__report .activity_column--room_label {\n  color: #333;\n}\n.roompicker-page .recent_room_checks .table {\n  color: #765d9f;\n}\n@media only screen and (max-width: 599px) {\n.toolbar .toolbar__content > *:not(.btn):not(.menu):first-child, .toolbar .toolbar__extension > *:not(.btn):not(.menu):first-child {\n    margin-left: 18px;\n}\n#app {\n    position: relative;\n}\n#app .menu__content--select:first-child {\n    top: 33% !important;\n    z-index: 9999 !important;\n    position: absolute;\n}\n}\n#app {\n  font-family: 'Akkurat', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\n#app-content {\n  position: relative;\n  z-index: inherit;\n}\n.toolbar .badge--overlap .badge__badge {\n  top: 4px;\n  right: 0px;\n}\n#request_demo {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  text-shadow: none !important;\n}\n", ""]);

// exports


/***/ }),

/***/ "QZBX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "R/yv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("rutx");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("45ea0cc2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db7d1a0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RoomPicker.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db7d1a0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RoomPicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "REYW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Bold.33f1e7c.woff";

/***/ }),

/***/ "RTaz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PKE/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b139811c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ri3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "report-page content-500" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Report for " + _vm._s(_vm.room.label))
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { name: "form" },
              model: {
                value: _vm.formValid,
                callback: function($$v) {
                  _vm.formValid = $$v
                },
                expression: "formValid"
              }
            },
            [
              _c(
                "table",
                { staticClass: "table table__report" },
                [
                  _c("colgroup", [
                    _c("col"),
                    _vm._v(" "),
                    _c("col"),
                    _vm._v(" "),
                    _c("col", { attrs: { width: "125px" } }),
                    _vm._v(" "),
                    _c("col")
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-left pr-1 pl-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Help")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-left pr-1 pl-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Resource")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-center px-1 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", "justify-space-between": "" } },
                            [
                              _c("strong", { staticClass: "pr-2" }, [
                                _vm._v("Working")
                              ]),
                              _vm._v(" "),
                              _c("strong", { staticClass: "pl-2" }, [
                                _vm._v("Broken")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-xs-center pl-1 pr-0 body-2",
                          attrs: { role: "columnheader" }
                        },
                        [_c("strong", [_vm._v("Notes")])]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.inventory, function(field, index) {
                    return [
                      _c(
                        "tr",
                        {
                          key: index,
                          staticClass: "field px-0",
                          attrs: { ripple: "" }
                        },
                        [
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "", "max-width": "350" },
                                  model: {
                                    value: _vm.form[field.featureId].issueHelp,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "issueHelp",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form[field.featureId].issueHelp"
                                  }
                                },
                                [
                                  field.featureLink
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            slot: "activator",
                                            flat: "",
                                            icon: ""
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "help-btn" },
                                            [_vm._v("help")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-toolbar",
                                        { attrs: { card: "" } },
                                        [
                                          _c("v-toolbar-title", [
                                            _vm._v(
                                              "Help: " +
                                                _vm._s(field.featureName)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                right: "",
                                                color: ""
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.form[
                                                    field.featureId
                                                  ].issueHelp = false
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("close")])],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("iframe", {
                                        staticClass: "iframe__help",
                                        attrs: {
                                          id: field.featureId + "_frame",
                                          src: field.featureLink,
                                          width: "100%",
                                          height: "450px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _c("span", { staticClass: "resource-name py-1" }, [
                              _vm._v(_vm._s(field.featureName))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "resource-description pb-1" },
                              [_vm._v(_vm._s(field.featureDescription))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center px-2" },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  ref: field.featureId + "_status",
                                  refInFor: true,
                                  staticClass:
                                    "radio_group__feature_status pt-0",
                                  attrs: {
                                    name:
                                      "form[" + field.featureId + "_status]",
                                    rules: [
                                      function(v) {
                                        return v !== null || ""
                                      }
                                    ],
                                    row: "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.form[field.featureId].status,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "status",
                                        $$v
                                      )
                                    },
                                    expression: "form[field.featureId].status"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    staticClass:
                                      "radio__feature_status__working pl-2",
                                    attrs: { value: true, color: "success" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    staticClass:
                                      "radio__feature_status__broken pr-1",
                                    attrs: { value: false, color: "error" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-0",
                                  attrs: {
                                    color: "grey",
                                    flat: "",
                                    depressed: "",
                                    small: "",
                                    fab: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showDialog(
                                        _vm.form[field.featureId]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.form[field.featureId].issueDescription
                                    ? _c("v-icon", [_vm._v("insert_comment")])
                                    : _c("v-icon", [_vm._v("mode_comment")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.form[field.featureId].status !==
                                            true,
                                          expression:
                                            "form[field.featureId].status !== true"
                                        }
                                      ],
                                      staticClass: "error--text required-marker"
                                    },
                                    [_vm._v("•")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "", "max-width": "350" },
                                  model: {
                                    value:
                                      _vm.form[field.featureId].issueDialog,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form[field.featureId],
                                        "issueDialog",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form[field.featureId].issueDialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-text-field", {
                                            ref:
                                              field.featureId +
                                              "_issueDescription",
                                            refInFor: true,
                                            attrs: {
                                              name:
                                                "form[" +
                                                field.featureId +
                                                "_issueDescription]",
                                              label: "Issue Description",
                                              rules: [
                                                function(v) {
                                                  return (
                                                    Boolean(
                                                      _vm.form[field.featureId]
                                                        .status === true ||
                                                        (typeof v ===
                                                          "string" &&
                                                          v.length)
                                                    ) || "Required"
                                                  )
                                                },
                                                function(v) {
                                                  return (
                                                    v.length <= 140 ||
                                                    "Max 140 characters"
                                                  )
                                                }
                                              ],
                                              "multi-line": "",
                                              counter: 140
                                            },
                                            model: {
                                              value:
                                                _vm.form[field.featureId]
                                                  .issueDescription,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form[field.featureId],
                                                  "issueDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form[field.featureId].issueDescription"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("p", { staticClass: "py-2" }, [
                                            _vm._v(
                                              "Remember: This description will be visible to clients. Please keep all language clear and professional."
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "grey",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteIssueDialog(
                                                    _vm.form[field.featureId]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("delete")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "btn__text" },
                                                [_vm._v("Discard")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.saveIssueDialog(
                                                    _vm.form[field.featureId]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("save")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "btn__text" },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-center my-4" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn__submit_report",
                      attrs: { disabled: !_vm.formValid, color: "success" },
                      on: {
                        click: function($event) {
                          return _vm.submitReport()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("send")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "btn__text" }, [
                        _vm._v("Submit Report")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { persistent: "", "max-width": "350" },
                      model: {
                        value: _vm.thankYouDialog,
                        callback: function($$v) {
                          _vm.thankYouDialog = $$v
                        },
                        expression: "thankYouDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "headline",
                              attrs: { "primary-title": "" }
                            },
                            [_vm._v("Thank You!")]
                          ),
                          _vm._v(" "),
                          _c("v-card-text", [
                            _c("p", [
                              _vm._v(
                                "Thank you for reporting! Your report has been queued, and will be sent shortly."
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "You may return to the Room Picker now, using the button below, or you will be redirected there automatically in " +
                                  _vm._s(_vm.roomPickerRedirectDelaySeconds) +
                                  " seconds."
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.goToRoomPicker()
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("forward")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "btn__text" }, [
                                      _vm._v("Back to Room Picker")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1d4164", esExports)
  }
}

/***/ }),

/***/ "S13Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateReports_vue__ = __webpack_require__("CpV4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1350a8ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateReports_vue__ = __webpack_require__("n6L1");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Mi0r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1350a8ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/GenerateReports.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1350a8ec", Component.options)
  } else {
    hotAPI.reload("data-v-1350a8ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SVxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    menuItems: function menuItems() {
      var _this = this;

      var items = this.$router.options.routes.filter(function (it) {
        return it.meta && it.meta.inMenu && it.meta.auth && _this.$auth.watch.authenticated && it.name !== 'Login';
      }).filter(function (it) {
        if (!_this.$teamService.currentTeamId && it.props === true) {
          return false;
        }
        return true;
      }).filter(function (it) {
        if (!it.meta.roles) return true;
        var user = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.user();
        var roles = user.roles;
        var currentTeamId = _this.$teamService.currentTeamId;
        var roleInCurrentTeam = user.roles[currentTeamId];
        var allowUser = it.meta.roles.includes(roleInCurrentTeam);
        return allowUser;
      });
      var logoutItem = false;
      if (items[items.length - 1].name === 'Logout') {
        logoutItem = items.pop();
      }
      if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.user().teams.length > 1) {
        items.push({
          name: 'Home',
          title: 'Switch Team',
          path: '/',
          component: 'Home',
          meta: {
            inMenu: true
          }
        });
      }
      if (logoutItem) {
        items.push(logoutItem);
      }
      return items;
    }
  }
});

/***/ }),

/***/ "St/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReports_vue__ = __webpack_require__("soo/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c62aed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReports_vue__ = __webpack_require__("Nw4Q");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("2tCf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c62aed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/StatusReports.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43c62aed", Component.options)
  } else {
    hotAPI.reload("data-v-43c62aed", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ty93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            {
              staticClass: "flex-wrap",
              class: _vm.$auth.watch.authenticated
                ? "authenticated"
                : "unauthenticated"
            },
            [
              !_vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "secondary" } },
                    [
                      _c("h3", { staticClass: "applogo nulogo" }, [
                        _vm._v("Northwestern")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "primary" } },
                    [
                      _c("h3", { staticClass: "applogo" }, [
                        _vm._v("Information Technology")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "primary" } },
                    [
                      _c(
                        "h3",
                        {
                          class: [
                            "applogo",
                            _vm.teamName ? "applogo--with-teamname" : ""
                          ]
                        },
                        [_vm._v("\n          Room Ready\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.teamName
                        ? _c("h4", { staticClass: "teamname white--text" }, [
                            _vm._v(_vm._s(_vm.teamName))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.$auth.watch.authenticated
                        ? _c(
                            "v-chip",
                            {
                              attrs: {
                                disabled: "",
                                small: "",
                                color: "white",
                                "text-color": "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(_vm.$auth.user().uid)
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.teamName,
                                      expression: "teamName"
                                    }
                                  ],
                                  staticStyle: { "margin-left": "0.5em" }
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$auth.user().roles[_vm.team.teamId]
                                      ) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$auth.watch.authenticated
                        ? _c(
                            "v-badge",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: {
                                overlap: "",
                                color: "transparent",
                                "content-class": "btn__sync btn--badge"
                              },
                              model: {
                                value: _vm.$syncService.items.length,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$syncService.items,
                                    "length",
                                    $$v
                                  )
                                },
                                expression: "$syncService.items.length"
                              }
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "badge" }, slot: "badge" },
                                [_vm._v(_vm._s(_vm.$syncService.items.length))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: _vm.$syncService.items.length
                                      ? "error"
                                      : "white",
                                    flat: "",
                                    round: "",
                                    icon: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$syncService.sync()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("sync")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("rr-main-menu")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-content",
                { attrs: { id: "app-content" } },
                [_c("flash-message"), _vm._v(" "), _c("router-view")],
                1
              ),
              _vm._v(" "),
              !_vm.$auth.watch.authenticated
                ? [
                    _c("footer", [
                      _c("div", { staticClass: "contain-970 group" }, [
                        _c("div", { staticClass: "footer-content" }, [
                          _c(
                            "a",
                            { attrs: { href: "http://www.northwestern.edu" } },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/img/northwestern-university.svg",
                                  alt: "Northwestern University"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "© " +
                                  _vm._s(_vm.currentYear) +
                                  " Northwestern University"
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/contact.html"
                                  }
                                },
                                [_vm._v("Contact Northwestern University")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/hr/careers/"
                                  }
                                },
                                [_vm._v("Careers")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/disclaimer.html"
                                  }
                                },
                                [_vm._v("Disclaimer")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/emergency/index.html"
                                  }
                                },
                                [_vm._v("Campus Emergency Information")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "http://policies.northwestern.edu/"
                                  }
                                },
                                [_vm._v("University Policies")]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "footer-content contact" }, [
                          _c("ul", [
                            _c("li", { staticClass: "footer-pin-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Address")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("strong", [_vm._v("Information Technology")])
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("1800 Sherman Avenue")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Evanston, IL 60201")])
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", { staticClass: "footer-phone-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Phone number")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("(847) 491-4357")])
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", { staticClass: "footer-email-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Email address")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:consultant@northwestern.edu"
                                  }
                                },
                                [_vm._v("consultant@northwestern.edu")]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "footer-content" }, [
                          _c("p", [_c("strong", [_vm._v("Social Media")])]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social facebook",
                              attrs: { href: "http://www.facebook.com/NU1HELP" }
                            },
                            [_vm._v("Facebook")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social twitter",
                              attrs: { href: "http://www.twitter.com/nu1help" }
                            },
                            [_vm._v("Twitter")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social youtube",
                              attrs: {
                                href:
                                  "http://www.youtube.com/user/nuitcommunications"
                              }
                            },
                            [_vm._v("YouTube")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "footer-content" },
                          [
                            _c(
                              "v-btn",
                              {
                                class: ["primary--text", "ma-0"],
                                attrs: {
                                  id: "request_demo",
                                  color: "white",
                                  block: "",
                                  href:
                                    "https://mediadesign.it.northwestern.edu/portfolio/roomready/",
                                  target: "_blank"
                                }
                              },
                              [
                                _c("strong", { staticClass: "btn__text" }, [
                                  _vm._v("Request a Demo")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { attrs: { role: "region", id: "roomready-version" } }, [
            _c("em", [_vm._v("v2.2.51")])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UpVO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nli.px-0 > .list__tile {\n  padding: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "VTGo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.2d275e1.jpg";

/***/ }),

/***/ "WBul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sync_vue__ = __webpack_require__("/1w6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4260014b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sync_vue__ = __webpack_require__("zLGT");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ptkG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sync_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4260014b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sync_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sync.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4260014b", Component.options)
  } else {
    hotAPI.reload("data-v-4260014b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XLHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sync',
  data: function data() {
    return {};
  },

  computed: {
    resetRoomsDisabled: function resetRoomsDisabled() {
      return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].roomsStore.state.RoomsCache.rooms).map(function (it) {
        return it[1].length;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    resetSyncDisabled: function resetSyncDisabled() {
      return !this.$syncService.items.length;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin__ = __webpack_require__("qbhH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TeamHome__ = __webpack_require__("5oIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RoomPicker__ = __webpack_require__("aqbE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Report__ = __webpack_require__("dc43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_StatusReports__ = __webpack_require__("St/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SuccinctReports__ = __webpack_require__("hd80");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_GenerateReports__ = __webpack_require__("S13Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Reset__ = __webpack_require__("EN1E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Sync__ = __webpack_require__("WBul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_roundsApiEndpoints__ = __webpack_require__("toSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_vue_openam_js__ = __webpack_require__("dOWj");
var _this = this;















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__services_vue_openam_js__["a" /* default */], { authUrl: __WEBPACK_IMPORTED_MODULE_13__constants_roundsApiEndpoints__["a" /* API_ENDPOINT_AUTH */], logoutUrl: __WEBPACK_IMPORTED_MODULE_13__constants_roundsApiEndpoints__["c" /* API_ENDPOINT_LOGOUT */] });

var NProgress = __webpack_require__("Y81h");
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 80
});
__webpack_require__("UVIz");

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    title: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    meta: {
      auth: false,
      inMenu: false
    }
  }, {
    path: '/:teamId/admin',
    name: 'Admin',
    title: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Admin__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true,
      roles: ['Staff']
    }
  }, {
    path: '/login',
    name: 'Login',
    title: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login__["a" /* default */], // TODO: Is this route even needed?
    meta: {
      auth: true,
      inMenu: false
    }
  }, {
    path: '/:teamId/room',
    name: 'RoomPicker',
    title: 'Room Picker',
    component: __WEBPACK_IMPORTED_MODULE_6__components_RoomPicker__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true
    }
  }, {
    path: '/:teamId/report/:roomId',
    name: 'Report',
    title: 'Report',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Report__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: false
    }
  }, {
    path: '/:teamId/sync',
    name: 'Sync',
    title: 'Sync Status',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Sync__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true
    }
  }, {
    path: '/:teamId/status',
    name: 'Status',
    title: 'Weekly Reports',
    component: __WEBPACK_IMPORTED_MODULE_8__components_StatusReports__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true,
      roles: ['Staff', 'Client']
    }
  }, {
    path: '/:teamId/summary',
    name: 'Summary',
    title: 'Summary Reports',
    component: __WEBPACK_IMPORTED_MODULE_9__components_SuccinctReports__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true,
      roles: ['Staff', 'Client']
    }
  }, {
    path: '/:teamId/generate-reports',
    name: 'GenerateReports',
    title: 'Generate Reports',
    component: __WEBPACK_IMPORTED_MODULE_10__components_GenerateReports__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: true,
      roles: ['Staff']
    }
  }, {
    path: '/reset',
    name: 'Reset',
    title: 'Reset',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Reset__["a" /* default */],
    meta: {
      auth: true,
      inMenu: false
    }
  }, {
    path: '/logout',
    name: 'Logout',
    title: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login__["a" /* default */], // TODO: Make this actually log out
    meta: {
      auth: true,
      inMenu: true
    }
  }, {
    path: '/:teamId',
    name: 'TeamHome',
    title: 'Team Home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_TeamHome__["a" /* default */],
    props: true,
    meta: {
      auth: true,
      inMenu: false
    }
  }, {
    path: '/*',
    redirect: { name: 'Home' }
  }]
});

// Helper function to send users to access denied with goto redirect
router.accessDenied = function (goto) {
  if (typeof goto === 'undefined') {
    goto = _this.a.currentRoute.path;
  }
  _this.a.push({
    name: 'Home',
    query: {
      goto: goto
    }
  });
};
router.afterEach(function (to, from) {
  NProgress.done();
});
router.beforeEach(function (to, from, next) {
  NProgress.start();
  if (to.meta.auth) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.authWorkflowComplete().then(function (authenticated) {
      if (!authenticated) {
        next({
          name: 'Home',
          query: {
            goto: to.path
          }
        });
        NProgress.done();
        // if the user has not logged in yet, redirect
      } else if (to.name === 'Logout') {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.authWorkflowComplete().then(function (authenticated) {
          next({
            path: '/'
          });
        });
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.logout();
        NProgress.done();
      } else if (!!to.params && !!to.params.teamId) {
        // Validate teamId path param against current user's teams
        if (!!__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$teamService.currentUserTeamIds.filter(function (it) {
          return it === to.params.teamId;
        }).length) {
          if (!!to.meta.roles && !to.meta.roles.find(function (role) {
            return role === __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.user().roles[to.params.teamId];
          })) {
            router.accessDenied();
          } else {
            next();
          }
        } else {
          next({ name: 'Home' });
        }
      } else {
        next();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$auth.ready();
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZKfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "page--status_reports" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Status Report (Summary)")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [
            _c("em", [_vm._v(_vm._s(_vm.lastChecked))])
          ]),
          _vm._v(" "),
          !!_vm.$roomService.rooms
            ? _c(
                "v-layout",
                { staticClass: "status_reports mt-4" },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "top-container top-container--full",
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "justify-space-around": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md4: "", sm12: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Rooms",
                                      "single-line": "",
                                      "hide-details": "",
                                      loading: _vm.$reportService.loading
                                    },
                                    model: {
                                      value: _vm.rawSearchTerms,
                                      callback: function($$v) {
                                        _vm.rawSearchTerms = $$v
                                      },
                                      expression: "rawSearchTerms"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showDepartmentUnit
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "sm-pt-4",
                                      attrs: { md4: "", sm12: "", xs12: "" }
                                    },
                                    [
                                      _c("v-select", {
                                        staticClass: "select__room_org_units",
                                        attrs: {
                                          items: _vm.roomOrgUnits,
                                          "item-text": "label",
                                          "item-value": "value",
                                          label: "Department / Unit",
                                          loading: _vm.$reportService.loading,
                                          autocomplete: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.filter.roomOrgUnit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filter,
                                              "roomOrgUnit",
                                              $$v
                                            )
                                          },
                                          expression: "filter.roomOrgUnit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "", sm12: "", xs12: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "select__room_owners",
                                    attrs: {
                                      items: _vm.roomOwners,
                                      "item-text": "label",
                                      "item-value": "value",
                                      label: "Owner",
                                      loading: _vm.$reportService.loading,
                                      autocomplete: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.roomOwner,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "roomOwner", $$v)
                                      },
                                      expression: "filter.roomOwner"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "", sm12: "", xs12: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "select__campusRegions",
                                    attrs: {
                                      items: _vm.roomCampusRegions,
                                      "item-text": "label",
                                      "item-value": "value",
                                      label: "Campus / Region",
                                      loading: _vm.$reportService.loading,
                                      autocomplete: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.roomCampusRegion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filter,
                                          "roomCampusRegion",
                                          $$v
                                        )
                                      },
                                      expression: "filter.roomCampusRegion"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "", sm3: "", xs6: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "nudge-right": 40,
                                        "full-width": "",
                                        "min-width": "290px"
                                      },
                                      model: {
                                        value: _vm.startDatePicker,
                                        callback: function($$v) {
                                          _vm.startDatePicker = $$v
                                        },
                                        expression: "startDatePicker"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          slot: "activator",
                                          label: "Start Date",
                                          "prepend-icon": "event",
                                          readonly: ""
                                        },
                                        slot: "activator",
                                        model: {
                                          value: _vm.displayDates.startDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.displayDates,
                                              "startDate",
                                              $$v
                                            )
                                          },
                                          expression: "displayDates.startDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-date-picker", {
                                        staticClass: "select__date",
                                        attrs: {
                                          "allowed-dates": {
                                            min: "1970-01-01",
                                            max: _vm.filter.endDate
                                          },
                                          label: "Start Date"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.startDatePicker = false
                                          }
                                        },
                                        model: {
                                          value: _vm.filter.startDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filter,
                                              "startDate",
                                              $$v
                                            )
                                          },
                                          expression: "filter.startDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md4: "", sm3: "", xs6: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "nudge-right": 40,
                                        "full-width": "",
                                        "min-width": "290px"
                                      },
                                      model: {
                                        value: _vm.endDatePicker,
                                        callback: function($$v) {
                                          _vm.endDatePicker = $$v
                                        },
                                        expression: "endDatePicker"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          slot: "activator",
                                          label: "End Date",
                                          "prepend-icon": "event",
                                          readonly: ""
                                        },
                                        slot: "activator",
                                        model: {
                                          value: _vm.displayDates.endDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.displayDates,
                                              "endDate",
                                              $$v
                                            )
                                          },
                                          expression: "displayDates.endDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-date-picker", {
                                        staticClass: "select__date",
                                        attrs: {
                                          "allowed-dates": {
                                            min: _vm.filter.startDate,
                                            max: _vm.utcString(_vm.now)
                                          },
                                          label: "End Date"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.endDatePicker = false
                                          }
                                        },
                                        model: {
                                          value: _vm.filter.endDate,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "endDate", $$v)
                                          },
                                          expression: "filter.endDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-lg-right",
                                  attrs: { md3: "", sm6: "", xs12: "" }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      label: "Only Show Overdue Rooms",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.filter.onlyOverdue,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "onlyOverdue", $$v)
                                      },
                                      expression: "filter.onlyOverdue"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.viewerIsRoomOwner
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "flex-flex text-xs-center",
                                      attrs: {
                                        md2: "",
                                        xs12: "",
                                        "offset-md2": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn__my_rooms",
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.filter.roomOwner = _vm.$auth.user().uid
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "btn__text" },
                                            [_vm._v("Show My Rooms")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "flex-flex text-xs-center",
                                  class: [
                                    _vm.viewerIsRoomOwner
                                      ? "offset-md3"
                                      : "offset-md7"
                                  ],
                                  attrs: { md2: "", xs12: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn__download",
                                      attrs: { color: "primary" },
                                      on: { click: _vm.downloadCSV }
                                    },
                                    [
                                      _c("span", { staticClass: "btn__text" }, [
                                        _vm._v("Download Report")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        ref: "reportsTable",
                        attrs: {
                          search: _vm.filter.searchTerms,
                          headers: _vm.reportsTableHeaders,
                          items: _vm.reportsTableItems,
                          pagination: _vm.pagination,
                          "custom-filter": _vm.customSearchFilter,
                          loading: _vm.$reportService.loading,
                          "item-key": "room_id",
                          "must-sort": "",
                          "hide-actions": "",
                          "no-results-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available.",
                          "no-data-text":
                            "Sorry, either there are no results available that match the search criteria, or data is not currently available."
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.pagination = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "headers",
                              fn: function(props) {
                                return [
                                  _c(
                                    "tr",
                                    { staticClass: "primary" },
                                    [
                                      _vm._l(props.headers, function(header) {
                                        return [
                                          !header.hide
                                            ? _c(
                                                "th",
                                                {
                                                  key: header.text,
                                                  class: [
                                                    header.sortable ||
                                                    header.align !== "left"
                                                      ? "px-1"
                                                      : "pr-1",
                                                    "white--text column column--" +
                                                      header.value,
                                                    "text-xs-" +
                                                      (header.align ||
                                                        "center"),
                                                    header.value ===
                                                    _vm.pagination.sortBy
                                                      ? "active"
                                                      : "",
                                                    header.sortable
                                                      ? "sortable"
                                                      : "",
                                                    _vm.pagination.descending
                                                      ? "desc"
                                                      : "asc"
                                                  ],
                                                  attrs: {
                                                    role: "columnheader",
                                                    "aria-label": header.text,
                                                    "aria-sort": header.sortable
                                                      ? "sortable"
                                                      : ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.changeSort(
                                                        header
                                                      )
                                                    },
                                                    mouseenter: function(
                                                      $event
                                                    ) {
                                                      header.tooltipOpen = true
                                                    },
                                                    mouseleave: function(
                                                      $event
                                                    ) {
                                                      header.tooltipOpen = false
                                                    }
                                                  }
                                                },
                                                [
                                                  header.sortable
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [_vm._v("arrow_upward")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(header.text) +
                                                      "\n                    "
                                                  ),
                                                  header.tooltip
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            bottom: "",
                                                            activator:
                                                              ".column--" +
                                                              header.value
                                                          },
                                                          model: {
                                                            value:
                                                              header.tooltipOpen,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                header,
                                                                "tooltipOpen",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "header.tooltipOpen"
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                header.tooltip
                                                                  .text
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              }
                            },
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_report px-1 text-xs-center"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: "",
                                                    disabled:
                                                      _vm.roomReportDialog
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openRoomReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("assignment")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  class: "ma-0",
                                                  attrs: {
                                                    color: "grey",
                                                    flat: "",
                                                    depressed: "",
                                                    small: "",
                                                    fab: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.startReport(
                                                        props.item.room_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [_vm._v("edit")])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_label pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.label) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showDepartmentUnit
                                    ? _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-xs-left column--org_unit pr-1"
                                        },
                                        [
                                          !!props.item.org_unit.line1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line1
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !!props.item.org_unit.line2
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "org_unit__line2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.org_unit
                                                          .line2
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--campus_region pr-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.campus_region) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: [
                                        "text-xs-right",
                                        "column--room_minimum_frequency",
                                        "px-1",
                                        props.item.check_status_color_class
                                      ]
                                    },
                                    [
                                      !!props.item.support_level
                                        ? _c(
                                            "v-tooltip",
                                            { attrs: { right: "" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item
                                                        .minimum_frequency
                                                    ) + " Days"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.support_level
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.minimum_frequency
                                              ) + " Days"
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-left column--room_last_checked pr-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            props.item.last_checked
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-right px-1 column--room_incident_count"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.incidentCount) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-right px-1 column--room_check_count"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.checkCount) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-right px-1 column--room_expected_check_count"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.minimumCheckCount) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-xs-right px-1 column--room_check_count"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("sub100Percent")(
                                              props.item.checkPercent
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { display: "none" } },
                                        [
                                          _vm._v(
                                            _vm._s(props.item.checkPercent)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          19563444
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            persistent: "",
                            scrollable: "",
                            "max-width": "90%",
                            "content-class": "dialog--room_status_reports"
                          },
                          model: {
                            value: _vm.roomReportDialog,
                            callback: function($$v) {
                              _vm.roomReportDialog = $$v
                            },
                            expression: "roomReportDialog"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-toolbar",
                                { attrs: { dark: "", color: "primary" } },
                                [
                                  _c("v-toolbar-title", [
                                    _vm._v(_vm._s(_vm.roomReportLabel))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", dark: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.closeRoomReport()
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.roomReportTableHeaders,
                                  items: _vm.roomReportTableItems,
                                  loading: _vm.$reportService.loading,
                                  "item-key": "report_id",
                                  "hide-actions": "",
                                  "no-results-text":
                                    "No reports are available for this room.",
                                  "no-data-text":
                                    "No reports are available for this room."
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-center column--room_status"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.getStatusIcon(
                                                      props.item.room_status
                                                    ).color
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStatusIcon(
                                                        props.item.room_status
                                                      ).icon
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--date"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    props.item.timestamp
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-xs-left column--notes"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "feature_bullet_list"
                                                },
                                                [
                                                  _vm._l(
                                                    props.item.inventory,
                                                    function(feature, index) {
                                                      return [
                                                        _c(
                                                          "li",
                                                          {
                                                            key: index,
                                                            class:
                                                              "feature_bullet_list_item feature_bullet_list_item--" +
                                                              _vm.getStatusIcon(
                                                                props.item[
                                                                  feature
                                                                    .featureId
                                                                ]
                                                              ).color
                                                          },
                                                          [
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "feature_bullet__name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      feature.featureName
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            props.item[
                                                              feature.featureId +
                                                                "_issue_description"
                                                            ]
                                                              ? _c(
                                                                  "em",
                                                                  {
                                                                    staticClass:
                                                                      "feature_bullet__notes"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          props
                                                                            .item[
                                                                            feature.featureId +
                                                                              "_issue_description"
                                                                          ]
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1764027880
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d57840f2", esExports)
  }
}

/***/ }),

/***/ "aMSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_business_days__ = __webpack_require__("w4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_business_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_roundsApiEndpoints__ = __webpack_require__("toSf");








var SYNC_FREQUENCY = 60; // Measured in seconds

// Sync Service Plugin

var SyncService = function () {
  function SyncService(Vue) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SyncService);

    this.Vue = Vue;
    this._store = Vue.syncStore;

    // Attempt a sync on initialization, just in case any older reports are still stuck in the sync queue
    this.sync();

    // Setup timer to attempt a sync every SYNC_FREQUENCY seconds
    this.syncTimer = setInterval(function () {
      _this.sync();
    }, SYNC_FREQUENCY * 1000);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SyncService, [{
    key: 'add',
    value: function add(data) {
      // Generate hashed value to use as item ID
      var timestamp = Date.now();
      var itemId = [data.roomId, data.userId, timestamp].join('|');

      // TODO: Update property names to match back-end
      var item = {
        report_id: itemId,
        room_id: data.roomId,
        room: data.room,
        label: data.label,
        timestamp: timestamp,
        date_only_timestamp: __WEBPACK_IMPORTED_MODULE_4_moment_business_days___default()(timestamp, 'x').format(),
        lastSent: null,
        status: 'pending',
        report_author: data.userId,
        report_author_user: data.user,
        report_sender: null,
        formData: data.form,
        teamId: data.teamId
      };

      this._store.dispatch('enqueue', { item: item });
      // TODO: Update room in room store to set last_checked to item.added

      // Log event in Google Analytics
      this.Vue.$ga.event({
        eventCategory: 'report',
        eventAction: 'submit' + data.roomStatus, // TODO: Should we differentiate between submit-working and submit-broken?
        eventLabel: item.label,
        eventValue: item.report_id
      });

      // Attempt to sync any items in queue
      this.sync(item);
    }
  }, {
    key: 'sync',
    value: function sync() {
      var syncItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.Vue.$auth.watch.authenticated) {
        /* Commenting out for now, isOnline doesn't compile down to ES5 correctly in build process
        isOnline().then(online => {
          // online var returns true or false
          if (online) {
            if (syncItem) {
              this.sendItem(syncItem);
            } else if (this.items) {
              var itemsToSend = this.items.filter(it => it.status !== 'sending');
              if (itemsToSend) {
                for (let item of itemsToSend) {
                  this.sendItem(item);
                }
              }
            }
          } else if (syncItem || this.items) {
            // this.Vue.eventService.$emit('flashMessage', {
            //   text: 'No internet connection available. Reports will attempt to send again shortly.',
            //   type: 'error'
            // });
          }
        }).catch((errOnline) => {
          console.log(errOnline);
        })
        */
        if (syncItem) {
          this.sendItem(syncItem);
        } else if (this.items) {
          var itemsToSend = this.items.filter(function (it) {
            return it.status !== 'sending';
          });
          if (itemsToSend) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(itemsToSend), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                this.sendItem(item);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: 'sendItem',
    value: function sendItem(item) {
      var _this2 = this;

      // If item is already being sent, don't send it again
      if (item.status === 'sending') {
        return;
      }
      item.status = 'sending';
      item.lastSent = Date.now();
      item.report_sender = this.Vue.$auth.user().uid;
      this._store.dispatch('updateItem', { item: item });

      var options = {
        credentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          teamId: item.teamId
        }
      };
      var body = {
        report: item
      };
      this.Vue.http.post(__WEBPACK_IMPORTED_MODULE_6__constants_roundsApiEndpoints__["d" /* API_ENDPOINT_REPORT */], body, options).then(function (res) {
        return res.json();
      }).then(
      // Success Calback
      function (response) {
        if (!response || response.errorMessage) {
          // Error Callback
          // TODO: Need to react to failure
          _this2.sendItemFailureCallback(item, response);
        } else {
          _this2.sendItemSuccessCallback(item, response);
        }
      },

      // Error Callback
      function (response) {
        _this2.sendItemFailureCallback(item, response);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'sendItemSuccessCallback',
    value: function sendItemSuccessCallback(item, response) {
      item.status = 'success';

      // Only trigger notification if item belongs to current team
      if (item.teamId === this.Vue.$teamService.currentTeamId) {
        this.Vue.eventService.$emit('flashMessage', {
          text: 'Report for ' + item.label + ' was successfully sent.',
          type: 'success'
        }); // TODO: Batch messages together if multiple succeed
      }
      this._store.dispatch('dequeue', { item: item });
    }
  }, {
    key: 'sendItemFailureCallback',
    value: function sendItemFailureCallback(item, response) {
      item.status = 'failed';
      item.report_sender = null;

      // Only trigger notification if item belongs to current team
      if (!item.failureNotified && item.teamId === this.Vue.$teamService.currentTeamId) {
        this.Vue.eventService.$emit('flashMessage', {
          text: 'Report for ' + item.label + ' failed to submit. Details of your report have been saved and admins have been notified; no more action is needed on your part.',
          type: 'error'
        }); // TODO: Batch messages together if multiple fail
        item.failureNotified = true;
      }

      this._store.dispatch('dequeue', { item: item });

      // Log exception in Google Analytics
      if (response && (response.length || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response).length)) {
        var exception = response.errorMessage || response;
        this.Vue.$ga.exception(exception);
      }

      // Log user out if request authorization fails
      if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
        this.Vue.$auth.logout().then(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].accessDenied);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._store.dispatch('clearQueue');
    }
  }, {
    key: 'items',
    get: function get() {
      return this._store.state.SyncQueue.queue;
    }
  }]);

  return SyncService;
}();

var syncService = {
  install: function install(Vue, options) {
    Vue.prototype.$syncService = new SyncService(Vue);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (syncService);

/***/ }),

/***/ "aqbE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoomPicker_vue__ = __webpack_require__("KKHJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db7d1a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoomPicker_vue__ = __webpack_require__("/UJm");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("R/yv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoomPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db7d1a0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoomPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/RoomPicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db7d1a0e", Component.options)
  } else {
    hotAPI.reload("data-v-db7d1a0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c3eI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.admin-page-links {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  padding: 20px;\n  font-size: 25px;\n  list-style: none;\n}\n.admin-page-links li {\n  background-color: #765d9f;\n  text-align: center;\n  width: calc(100%/3 - 8rem);\n  height: 100px;\n  line-height: 100px;\n}\n.admin-page-links li:hover{\n      -webkit-box-shadow: 2px 2px 2px 2px rgb(186, 172, 195);\n              box-shadow: 2px 2px 2px 2px rgb(186, 172, 195);\n      -webkit-transition: 0.3s;\n      transition: 0.3s;\n}\n.admin-page-links a {\n      color: black;\n      text-decoration: none;\n}\n@media only screen and (max-width: 1020px) {\n.admin-page-links {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.admin-page-links li {\n  width: 60%;\n  height: auto;\n  margin: 1rem\n}\n}\n@media only screen and (max-width: 400px) {\n.admin-page-links li {\n      height: 70px;\n      line-height: normal;\n      padding: 10px 0\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "cydc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Bold.4b356bb.eot";

/***/ }),

/***/ "dOWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);





var AUTH_HTML_URL = window.location.origin + '/static/auth.html';
// https://learninggames.northwestern.edu/geo/auth.html
var LOGIN_URL = "https://prd-nusso.it.northwestern.edu/nusso?goto=" + window.location.href;
var LOGOUT_URL = "https://prd-nusso.it.northwestern.edu/nusso/XUI#logout&goto=" + window.location.href;
var SSO_COOKIE_NAME = "nusso";
var JWT_COOKIE_NAME = 'roomReadyJWT_v2-1-0';
var JWT_COOKIE_DOMAIN = '.roomready.northwestern.edu';

//@TODO: move this to the instantiation of the class
var VALID_ORIGINS = [window.location.origin];

var VueOpenAMAuth = function () {
    function VueOpenAMAuth(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VueOpenAMAuth);

        var _this = this;
        this.options = options;
        this.options.Vue = Vue;
        this.watch = new this.options.Vue({
            data: function data() {
                return {
                    data: null,
                    loaded: false,
                    redirect: null,
                    processing: false,
                    authenticated: false,
                    authWorkflowComplete: false
                };
            },

            watch: {
                loaded: function loaded(val) {
                    if (val === true && _this.options.readyCallback) {
                        _this.options.readyCallback();
                    }
                }
            }
        });
        this.login_window = null;
        this.valid_origins = options.valid_origins || VALID_ORIGINS;
        window.addEventListener("message", this.receiveMessage.bind(this), false);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VueOpenAMAuth, [{
        key: "isLoaded",
        value: function isLoaded() {
            var _this = this;
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                _this.ready();
                var authLoadedTimer = setInterval(function () {
                    if (_this.watch.loaded) {
                        clearInterval(authLoadedTimer);
                        resolve();
                    }
                }, 100);
            });
        }
    }, {
        key: "authWorkflowComplete",
        value: function authWorkflowComplete() {
            var _this2 = this;

            var _this = this;
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                _this2.watch.authWorkflowComplete = false;
                var authWorkflowTimer = setInterval(function () {
                    if (_this.watch.authWorkflowComplete) {
                        clearInterval(authWorkflowTimer);
                        resolve(_this.watch.authenticated);
                    }
                }, 100);
            });
        }
    }, {
        key: "userLoginSuccessful",
        value: function userLoginSuccessful() {
            var _this = this;
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                var userLoginSuccessfulTimer = setInterval(function () {
                    if (_this.watch.authenticated) {
                        clearInterval(userLoginSuccessfulTimer);
                        resolve();
                    }
                }, 100);
            });
        }
    }, {
        key: "validateOrigin",
        value: function validateOrigin(origin) {
            return this.valid_origins.indexOf(origin) >= 0;
        }
    }, {
        key: "receiveMessage",
        value: function receiveMessage(e) {
            if (e.data && e.data.length && e.data.match(/^pym/)) {
                console.log("ignoring message from pym.js");
                return;
            }

            // Login events return and empty event object. We need to return here for other
            // window message events, since this event handler is used by other components
            // (react, react dev tools, webpack hot reload)
            if (!this.validateOrigin(e.origin)) {
                return;
            }

            if (this.login_window) {
                this.login_window.close();
            }
            this.authenticate();
        }
    }, {
        key: "authenticate",
        value: function authenticate() {
            var _this3 = this;

            this.watch.processing = true;
            this.getAttributes(function (err, userdata) {
                if (err) {
                    _this3.watch.authenticated = false;
                    _this3.user(null);
                    _this3.watch.processing = false;
                } else {
                    _this3.watch.authenticated = true;
                    _this3.user(userdata);
                    _this3.watch.processing = false;
                }
                _this3.watch.authWorkflowComplete = true;
            });
            this.watch.loaded = true;
        }
    }, {
        key: "getAttributes",
        value: function getAttributes(callback) {
            var KEY = "subjectid";
            var url = this.options.authUrl;

            var opts = {
                credentials: 'include'
            };
            fetch(url, opts).then(function (res) {
                return res.json();
            }).then(function (attrs) {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attrs).length === 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(attrs.attributes) !== 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attrs.attributes).length === 0) {
                    callback('not authenticated');
                    console.log('not authenticated');
                    return;
                }

                callback(null, attrs.attributes);
            }).catch(function (err) {
                callback(err);
            });
        }
    }, {
        key: "parseAttrs",
        value: function parseAttrs(attrs) {
            var rows = attrs.split("\n");
            var key = null;
            var old_key = null;
            var value = [];

            var data = {};

            var cleanKey = function cleanKey(key) {
                return key.replace("userdetails.attribute.", "", key);
            };

            for (var i = 0; i < rows.length; i++) {
                // key or value?
                var pair = rows[i].split("=");
                var left = pair.shift();
                var right = pair.join("=");

                if (left.match(/name$/)) {
                    key = cleanKey(right);
                    data[key] = [];
                    continue;
                } else if (left.match(/value$/)) {
                    data[key].push(right);
                }
            }
            // convert arrays with single item to strings.
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
                if (data[key].length === 1) {
                    data[key] = data[key][0];
                }
            });

            return data;
        }
    }, {
        key: "ready",
        value: function ready() {
            this.authenticate();
        }
    }, {
        key: "redirect",
        value: function redirect() {
            return this.watch.redirect;
        }
    }, {
        key: "user",
        value: function user(data) {
            if (data) {
                this.watch.data = data;
            }
            return this.watch.data || {};
        }
    }, {
        key: "login",
        value: function login() {
            window.location.href = LOGIN_URL;
        }
    }, {
        key: "logout",
        value: function logout() {
            console.log("logout");
            var _this = this;
            this.watch.authWorkflowComplete = false;

            fetch(this.options.logoutUrl, { credentials: 'include' }).then(function () {
                window.location.href = LOGOUT_URL;
            });
        }
    }]);

    return VueOpenAMAuth;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, opts) {
        var auth = new VueOpenAMAuth(Vue, opts);
        Vue.$auth = auth;
        Vue.prototype.$auth = auth;
    }
});

/***/ }),

/***/ "dT2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MutationTypes__ = __webpack_require__("vjNh");


var _mutations;



var state = {
  queue: [],
  syncStatus: null, // TODO: Add actions and mutators for updating syncStatus
  schemaVersion: '2.0'
};

var getters = {
  queue: function queue(state) {
    return state.queue;
  }
};

var actions = {
  enqueue: function enqueue(_ref, item) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["g" /* SYNC_ENQUEUE */], item);
  },
  dequeue: function dequeue(_ref2, item) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["f" /* SYNC_DEQUEUE */], item);
  },
  updateItem: function updateItem(_ref3, item) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["f" /* SYNC_DEQUEUE */], item);
    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["g" /* SYNC_ENQUEUE */], item);
  },
  clearQueue: function clearQueue(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["e" /* SYNC_CLEAR */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__MutationTypes__["g" /* SYNC_ENQUEUE */], function (state, _ref5) {
  var item = _ref5.item;

  // If item is not already enqueued, add it to the queue
  if (!state.queue.length || !state.queue.filter(function (queueItem) {
    return queueItem.itemId === item.itemId;
  }).length) {
    state.queue.push(item);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__MutationTypes__["f" /* SYNC_DEQUEUE */], function (state, _ref6) {
  var item = _ref6.item;

  if (state.queue.length) {
    state.queue = state.queue.filter(function (queueItem) {
      return queueItem.itemId !== item.itemId;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__MutationTypes__["e" /* SYNC_CLEAR */], function (state) {
  state.queue = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "dc43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__("ybql");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1d4164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__("Ri3b");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("2wgF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1d4164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Report.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f1d4164", Component.options)
  } else {
    hotAPI.reload("data-v-5f1d4164", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/uT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'flash-message',
    data: function data() {
        return {
            messages: []
        };
    },
    created: function created() {
        this.$eventService.$on('flashMessage', this.addMessage);
    },

    methods: {
        getIcon: function getIcon(type) {
            switch (type) {
                case 'success':
                    return 'check_circle';
                    break;
                case 'info':
                    return 'info';
                    break;
                case 'warning':
                    return 'priority_high';
                    break;
                case 'error':
                    return 'warning';
                    break;
            }
        },
        addMessage: function addMessage(message) {
            {
                this.messages.push({
                    text: message.text,
                    type: typeof message.type == 'undefined' ? 'info' : message.type,
                    icon: this.getIcon(typeof message.type == 'undefined' ? 'info' : message.type),
                    show: typeof message.show == 'undefined' ? true : message.show,
                    timeout: typeof message.timeout == 'undefined' ? 3000 : message.timeout,
                    important: typeof message.important == 'undefined' ? false : message.important,
                    remove: function remove() {
                        this.show = false;
                    },
                    handleShowEvent: function handleShowEvent() {
                        var _this = this;

                        {
                            if (!this.important) {
                                setTimeout(function () {
                                    return _this.remove();
                                }, this.timeout);
                            }
                        }
                    }
                });
            }
        }
    },
    computed: {
        messagesToShow: function messagesToShow() {
            return this.messages.filter(function (it) {
                return it.show;
            });
        }
    },
    events: {
        flashMessage: function flashMessage(message) {
            this.addMessage(message);
        }
    }
});

/***/ }),

/***/ "fBFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_localstorage__ = __webpack_require__("kQU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_SyncQueue__ = __webpack_require__("dT2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_RoomsCache__ = __webpack_require__("mzXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_TeamsCache__ = __webpack_require__("yJkg");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = {
  install: function install(Vue, options) {
    // Install Sync Queue Store
    Vue.syncStore = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
      plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default()({
        namespace: 'queue-store',
        initialState: __WEBPACK_IMPORTED_MODULE_3__modules_SyncQueue__["a" /* default */].state
      })],
      modules: {
        SyncQueue: __WEBPACK_IMPORTED_MODULE_3__modules_SyncQueue__["a" /* default */]
      }
    });

    // Install Room Store
    Vue.roomsStore = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
      plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default()({
        namespace: 'rooms-store',
        initialState: __WEBPACK_IMPORTED_MODULE_4__modules_RoomsCache__["a" /* default */].state
      })],
      modules: {
        RoomsCache: __WEBPACK_IMPORTED_MODULE_4__modules_RoomsCache__["a" /* default */]
      }
    });

    // Install Room Store
    Vue.teamsStore = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
      plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_localstorage___default()({
        namespace: 'teams-store',
        initialState: __WEBPACK_IMPORTED_MODULE_5__modules_TeamsCache__["a" /* default */].state
      })],
      modules: {
        TeamsCache: __WEBPACK_IMPORTED_MODULE_5__modules_TeamsCache__["a" /* default */]
      }
    });

    // Clear Cache Stores if Local Storage Uses Old Schema
    if (Vue.roomsStore.state.RoomsCache.rooms.constructor === Array || Vue.roomsStore.state.RoomsCache.inventory.constructor === Array) {
      Vue.roomsStore.dispatch('clearCache');
      Vue.syncStore.dispatch('clearQueue');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "hd80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccinctReports_vue__ = __webpack_require__("+0oY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d57840f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccinctReports_vue__ = __webpack_require__("ZKfx");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("uuud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuccinctReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d57840f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuccinctReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SuccinctReports.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d57840f2", Component.options)
  } else {
    hotAPI.reload("data-v-d57840f2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hfL9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\ntd.column--room_report {\n  width: 96px;\n}\ntd.column--room_label {\n  min-width: 140px;\n}\ntd.column--org_unit {\n  min-width: 90px;\n}\ntd.column--room_minimum_frequency {\n  min-width: 50px;\n}\ntd.column--room_last_checked {\n  min-width: 105px;\n}\ntable.table thead th.column--room_status,\ntable.table tbody td.column--room_status {\n  min-width: 50px;\n  max-width: 50px;\n  white-space: normal;\n}\ntable.table thead th.column--room_status {\n  border-left: 1px solid rgba(131, 110, 170, .5);\n}\n/* table.table thead th.column--room_status:nth-child(2n) {\n  background-color: #401f68;\n} */\ntable.table tbody td.column--room_status:nth-child(2n) {\n  background-color: rgba(131, 110, 170, .07);\n  border-left: 1px solid transparent;\n}\n.dialog--room_status_reports tr th:nth-child(2),\n.dialog--room_status_reports tr td:nth-child(2) {\n  width: 130px;\n}\ndiv.flex {\n  max-width: 100%;\n}\n.top-container {\n  max-width: 600px;\n}\n.top-container--full {\n  max-width: 100%;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "iCXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.$auth.watch.authenticated
        ? _c("v-card-text", { staticClass: "instructions-page content-500" }, [
            _c("h2", { staticClass: "page-title" }, [
              _vm._v("Using The RoomReady App")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-xs-left" }, [
              _c("div", { staticClass: "instructions" }, [
                _c("ol", [
                  _c("li", [
                    _vm._v(
                      "Please make sure you are using either Chrome or Safari (without incognito or private browsing mode)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Select a campus, building and room")]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("Check that all room technology is functional")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Add notes to inoperable items, or those that required repair"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Submit your room report")])
                ])
              ]),
              _vm._v(" "),
              !!_vm.team && !!_vm.team.preRoundsInstructions
                ? _c("div", { staticClass: "reminders" }, [
                    _c("p", [_vm._v(_vm._s(_vm.team.preRoundsInstructions))])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.$auth.watch.authenticated
              ? _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          to: "/" + _vm.teamId + "/room",
                          color: "primary"
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("forward")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Start Rounds")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("exit_to_app")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Logout")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b3ef1e8", esExports)
  }
}

/***/ }),

/***/ "jdn0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c3eI");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4e3d1361", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1fd8a062\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Admin.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1fd8a062\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Admin.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kP2y":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#alerts-banner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: auto;\n  z-index: 7;\n}\n", ""]);

// exports


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc7cce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("s6hi");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc7cce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8dc7cce2", Component.options)
  } else {
    hotAPI.reload("data-v-8dc7cce2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m6y1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AkkuratPro-Regular.85acb92.svg";

/***/ }),

/***/ "mzXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MutationTypes__ = __webpack_require__("vjNh");




var _mutations;




var state = {
  rooms: {},
  inventory: {},
  schemaVersion: '2.0'
};

var getters = {
  rooms: function rooms(state) {
    return state.rooms;
  },
  inventory: function inventory(state) {
    return state.inventory;
  }
};

var actions = {
  updateRooms: function updateRooms(_ref, items) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__MutationTypes__["d" /* ROOMS_UPDATE */], items);
  },
  updateInventory: function updateInventory(_ref2, items) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__MutationTypes__["c" /* ROOMS_INVENTORY_UPDATE */], items);
  },
  clearCache: function clearCache(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__MutationTypes__["a" /* ROOMS_CLEAR */]);
    commit(__WEBPACK_IMPORTED_MODULE_4__MutationTypes__["b" /* ROOMS_INVENTORY_CLEAR */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__MutationTypes__["d" /* ROOMS_UPDATE */], function (state, _ref4) {
  var items = _ref4.items,
      teamId = _ref4.teamId;

  if (state.rooms[teamId] === undefined) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.rooms, teamId, []);
  }
  if (items.length) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.rooms, teamId, items);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__MutationTypes__["c" /* ROOMS_INVENTORY_UPDATE */], function (state, _ref5) {
  var items = _ref5.items,
      teamId = _ref5.teamId;

  if (state.inventory[teamId] === undefined) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.inventory, teamId, []);
  }
  if (items.length) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.inventory, teamId, items);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__MutationTypes__["a" /* ROOMS_CLEAR */], function (state) {
  if (state.rooms.constructor === Array) {
    state.rooms = {};
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.rooms)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var teamId = _step.value;

      state.rooms[teamId] = [];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__MutationTypes__["b" /* ROOMS_INVENTORY_CLEAR */], function (state) {
  if (state.inventory.constructor === Array) {
    state.inventory = {};
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.inventory)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var teamId = _step2.value;

      state.inventory[teamId] = [];
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "n6L1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "page--generate_reports", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "text-xs-center" },
        [
          _c("h2", { staticClass: "page-title" }, [
            _vm._v("Generate Custom Reports")
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "report-field-group",
              attrs: { row: "", wrap: "", "justify-center": "" }
            },
            [
              _c("v-flex", { attrs: { xs12: "", md10: "" } }, [
                _c("h3", { staticClass: "text-xs-left title" }, [
                  _vm._v("Reports Submitted per Team Member:")
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", md4: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "teamUsageStartDate",
                      class: "mr-3",
                      attrs: {
                        lazy: "",
                        "close-on-content-click": true,
                        transition: "scale-transition",
                        "offset-y": "",
                        "full-width": "",
                        "nudge-right": 40,
                        "min-width": "290px",
                        "return-value": _vm.teamUsage.values.startDate
                      },
                      on: {
                        "update:returnValue": function($event) {
                          return _vm.$set(
                            _vm.teamUsage.values,
                            "startDate",
                            $event
                          )
                        },
                        "update:return-value": function($event) {
                          return _vm.$set(
                            _vm.teamUsage.values,
                            "startDate",
                            $event
                          )
                        }
                      },
                      model: {
                        value: _vm.teamUsage.values.startDateMenu,
                        callback: function($$v) {
                          _vm.$set(_vm.teamUsage.values, "startDateMenu", $$v)
                        },
                        expression: "teamUsage.values.startDateMenu"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          slot: "activator",
                          label: "Start Date",
                          "prepend-icon": "event",
                          readonly: ""
                        },
                        slot: "activator",
                        model: {
                          value: _vm.teamUsage.values.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.teamUsage.values, "startDate", $$v)
                          },
                          expression: "teamUsage.values.startDate"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-date-picker",
                        {
                          attrs: { "no-title": "", scrollable: "" },
                          model: {
                            value: _vm.teamUsage.values.startDate,
                            callback: function($$v) {
                              _vm.$set(_vm.teamUsage.values, "startDate", $$v)
                            },
                            expression: "teamUsage.values.startDate"
                          }
                        },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.teamUsage.values.startDate = null
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.teamUsageStartDate.save(
                                    _vm.teamUsage.values.startDate
                                  )
                                }
                              }
                            },
                            [_vm._v("OK")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", md4: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "teamUsageEndDate",
                      class: "mr-3",
                      attrs: {
                        lazy: "",
                        "close-on-content-click": true,
                        transition: "scale-transition",
                        "offset-y": "",
                        "full-width": "",
                        "nudge-right": 40,
                        "min-width": "290px",
                        "return-value": _vm.teamUsage.values.endDate
                      },
                      on: {
                        "update:returnValue": function($event) {
                          return _vm.$set(
                            _vm.teamUsage.values,
                            "endDate",
                            $event
                          )
                        },
                        "update:return-value": function($event) {
                          return _vm.$set(
                            _vm.teamUsage.values,
                            "endDate",
                            $event
                          )
                        }
                      },
                      model: {
                        value: _vm.teamUsage.endDateMenu,
                        callback: function($$v) {
                          _vm.$set(_vm.teamUsage, "endDateMenu", $$v)
                        },
                        expression: "teamUsage.endDateMenu"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          slot: "activator",
                          label: "End Date",
                          "prepend-icon": "event",
                          readonly: ""
                        },
                        slot: "activator",
                        model: {
                          value: _vm.teamUsage.values.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.teamUsage.values, "endDate", $$v)
                          },
                          expression: "teamUsage.values.endDate"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-date-picker",
                        {
                          attrs: { "no-title": "", scrollable: "" },
                          model: {
                            value: _vm.teamUsage.values.endDate,
                            callback: function($$v) {
                              _vm.$set(_vm.teamUsage.values, "endDate", $$v)
                            },
                            expression: "teamUsage.values.endDate"
                          }
                        },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.teamUsage.values.endDate = null
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.teamUsageEndDate.save(
                                    _vm.teamUsage.values.endDate
                                  )
                                }
                              }
                            },
                            [_vm._v("OK")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", md2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        primary: "",
                        block: "",
                        disabled: _vm.teamUsageInvalid,
                        download: "",
                        href: _vm.generateReportUrl("teamUsage")
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("assignment")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "btn__text" }, [
                        _vm._v("Get Report")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1350a8ec", esExports)
  }
}

/***/ }),

/***/ "n9Os":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$auth.watch.authenticated
    ? _c(
        "v-menu",
        { attrs: { bottom: "", left: "", "offset-y": "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                slot: "activator",
                color: "white",
                flat: "",
                round: "",
                icon: ""
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("more_vert")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm._l(_vm.menuItems, function(item) {
                return [
                  _c(
                    "v-list-tile",
                    {
                      key: item.name,
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: item.name,
                            params: { teamId: _vm.$teamService.currentTeamId }
                          })
                        }
                      }
                    },
                    [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beffe230", esExports)
  }
}

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            msg: 'login'
        };
    },
    mounted: function mounted() {
        this.loadRooms();
    },

    methods: {
        loadRooms: function loadRooms() {
            this.rooms = [{ name: "foo" }];
        }
    }
});

/***/ }),

/***/ "oBIz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/social-media-icons.f429ae8.png";

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pPfB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LLoF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0c7a28ca", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6766c9cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reset.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6766c9cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reset.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pgH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", id: "alerts-banner" } },
    [
      _vm._l(_vm.messages, function(message, index) {
        return [
          _c(
            "v-alert",
            {
              key: index,
              attrs: {
                value: message.show,
                color: message.type,
                icon: message.icon,
                transition: "slide-x-reverse-transition"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(message.handleShowEvent()) +
                  "\n            "
              ),
              _c("strong", [_vm._v(_vm._s(message.text))])
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29ce9aa7", esExports)
  }
}

/***/ }),

/***/ "ptkG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UpVO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5b1a42cc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4260014b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sync.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4260014b\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sync.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qbhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__("KS52");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd8a062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__("666/");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("jdn0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd8a062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Admin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fd8a062", Component.options)
  } else {
    hotAPI.reload("data-v-1fd8a062", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rVG2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Campton-Bold.ffeae1e.svg";

/***/ }),

/***/ "rutx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.menu__content--select .room-list-last-checked {\n  float: right;\n  color: rgba(0,0,0,.54);\n}\n.table__report .activity_column--room_last_checked {\n  max-width: 130px;\n}\n.table__report .activity_column--room_label {\n  width: auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "s6ZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.$auth.watch.authenticated
        ? _c("v-card-text", { staticClass: "instructions-page content-500" }, [
            _c("h2", { staticClass: "page-title" }, [
              _vm._v("Select your team")
            ]),
            _vm._v(" "),
            _vm.userTeams.length === 0
              ? _c("p", [_vm._v("You are not a member of any teams yet")])
              : _vm._e(),
            _vm._v(" "),
            _vm.$auth.watch.authenticated
              ? _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-radio-group",
                      {
                        attrs: { mandatory: true },
                        model: {
                          value: _vm.teamSelection,
                          callback: function($$v) {
                            _vm.teamSelection = $$v
                          },
                          expression: "teamSelection"
                        }
                      },
                      [
                        _vm._l(_vm.userTeams, function(team, index) {
                          return [
                            _c("v-radio", {
                              key: index,
                              attrs: {
                                label: team.teamName,
                                value: team.teamId,
                                color: "primary"
                              }
                            })
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          disabled:
                            !_vm.userTeams.length || _vm.teamSelection === null
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToTeamHome()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("forward")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Select Team")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("exit_to_app")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Logout")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$auth.watch.authenticated
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "alert--outline",
                  attrs: { icon: "warning", color: "error--text" },
                  model: {
                    value: _vm.accessDenied,
                    callback: function($$v) {
                      _vm.accessDenied = $$v
                    },
                    expression: "accessDenied"
                  }
                },
                [
                  _c("strong", [
                    _vm._v("You must login before you can view this page.")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hero-wrapper" },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        column: "",
                        "align-center": "",
                        "justify-center": ""
                      }
                    },
                    [
                      _c("h1", { staticClass: "hero small-text white--text" }, [
                        _vm._v("RoomReady")
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "hero large-text white--text" }, [
                        _vm._v("Room checks made easy.")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$auth.watch.processing,
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.login()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "custom-button btn__text netid" },
                            [_vm._v("Login with Netid")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}

/***/ }),

/***/ "soo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_business_days__ = __webpack_require__("w4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_business_days__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Make whole room clickable to trigger roomReport


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatusReports',
  data: function data() {
    return {
      rawSearchTerms: '',
      searchTimeout: -1,
      debouncePeriod: 500,
      searchKeys: ['active_status', 'campus', 'campus_region', 'customer_or_owner', 'email_primary_owner', 'email_secondary_owner', 'label', 'netid_primary_owner', 'primary_contact_name', 'room_type', 'secondary_contact_name', 'secondary_customer_or_owner'],
      filter: {
        searchTerms: '',
        roomOwner: '',
        roomOrgUnit: '',
        onlyOverdue: false
      },
      pagination: {
        sortBy: 'last_checked',
        descending: true,
        rowsPerPage: -1,
        page: 1
      },
      roomReportDialog: false,
      roomReportRoomId: null,
      now: Date.now()
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    startReport: function startReport(roomId) {
      var teamId = this.teamId;
      this.$router.push({
        path: '/' + teamId + '/report/' + roomId
      });
    },
    loadData: function loadData() {
      this.$reportService.refreshData(this.teamId);
      this.$roomService.refreshData(this.teamId);
    },
    customSearchFilter: function customSearchFilter(items, search, filter) {
      var _this = this;

      search = search.toString().toLowerCase();

      if (this.filter.onlyOverdue) {
        items = items.filter(function (it) {
          return !!it.check_overdue;
        });
      }

      // Apply organizational owner filter
      if (this.filter.roomOrgUnit) {
        items = items.filter(function (it) {
          return it.org_unit.line1 === _this.filter.roomOrgUnit || it.org_unit.value === _this.filter.roomOrgUnit;
        });
      }

      // Apply room owner filter
      if (this.filter.roomOwner) {
        items = items.filter(function (it) {
          return it.netid_primary_owner === _this.filter.roomOwner || it.netid_secondary_owner === _this.filter.roomOwner;
        });
      }

      // Apply keyword search filters
      if (search) {
        // Split the search terms up by space, and search for all of them
        var searchTerms = search.split(" ");
        items = items.filter(function (i) {
          return searchTerms.every(function (term) {
            return _this.searchKeys.some(function (j) {
              return filter(i[j], term);
            });
          });
        });
      }

      return items;
    },
    changeSort: function changeSort(header) {
      if (header.sortable !== false) {
        var column = header.value;
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    openRoomReport: function openRoomReport(roomId) {
      this.roomReportRoomId = roomId;
      this.roomReportDialog = true;
    },
    closeRoomReport: function closeRoomReport() {
      // this.roomReportRoomId = null; // TODO: Maybe re-enable this?
      this.roomReportDialog = false;
    },
    getStatusIcon: function getStatusIcon(status) {
      if (status === true) {
        return {
          color: 'success',
          icon: 'check_circle'
        };
      } else if (status === false) {
        return {
          color: 'warning',
          icon: 'warning'
        };
      } else {
        return {
          color: 'grey lighten-1',
          icon: 'do_not_disturb_on'
        };
      }
    },
    finishSearchDebounce: function finishSearchDebounce() {
      this.filter.searchTerms = this.rawSearchTerms;
    }
  },
  computed: {
    weeks: function weeks() {
      if (this.$reportService.reports) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.$reportService.reports.filter(function (it) {
          return !!it.date_year_week;
        }).map(function (it) {
          return it.date_year_week;
        }))).sort().reverse();
      }
      return [];
    },
    reportsTableHeaders: function reportsTableHeaders() {
      var headers = [{
        text: 'Actions',
        align: 'left',
        sortable: false
      }, {
        text: 'Room',
        align: 'left',
        value: 'label'
      }, {
        text: 'Dept. / Unit',
        align: 'left',
        value: 'org_unit.value',
        sortable: true,
        hide: !this.showDepartmentUnit
      }, {
        text: 'Campus',
        align: 'left',
        value: 'campus',
        sortable: true
      }, {
        text: 'Region',
        align: 'left',
        value: 'campus_region',
        sortable: true
      }, {
        text: 'Frequency',
        align: 'right',
        value: 'minimum_frequency',
        sortable: true
      }, {
        text: 'Last Checked',
        align: 'left',
        value: 'last_checked'
      }];
      if (this.weeks) {
        headers = headers.concat(this.weeks.map(function (week) {
          return {
            text: __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(week, 'YYYYWW').startOf('week').format('M/D') + ' - ' + __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(week, 'YYYYWW').endOf('week').format('M/D'),
            value: 'room_status_' + week,
            isWeekHeader: true,
            align: 'center',
            sortable: false
          };
        }));
      }
      return headers;
    },
    reportsTableItems: function reportsTableItems() {
      var rooms = this.$roomService.rooms;
      var reports = this.$reportService.reports;

      if (rooms && reports) {
        rooms = rooms.map(function (room) {
          // Check for and mark whether rooms are overdue
          var business_days_since_check = __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(room.last_checked, 'x').endOf('day').businessDiff(__WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()().endOf('day'));
          room.check_status_color_class = '';
          if (business_days_since_check > room.minimum_frequency || !room.last_checked) {
            room.check_status_color_class = 'error--text';
            room.check_overdue = true;
          } else {
            room.check_overdue = false;
          }
          // Uncomment lines below to color code checks due today as yellow
          // else if(business_days_since_check == room.minimum_frequency) {
          //   room.check_status_color_class = 'warning--text'
          //   room.check_overdue = false;
          // }

          // Insert report status for each week into the room object
          reports.filter(function (it) {
            return it.room_id === room.room_id && !!it.date_year_week;
          }).forEach(function (report) {
            room['room_status_' + report.date_year_week] = report.room_status;
          });

          // Add data for department / unit column
          room.org_unit = {
            value: '',
            line1: '',
            line2: ''
          };
          if (!!room.customer_or_owner) {
            room.org_unit.line1 = room.customer_or_owner;
            if (!!room.secondary_customer_or_owner) {
              room.org_unit.line2 = room.secondary_customer_or_owner;
            }
            room.org_unit.value = room.org_unit.line1 + ' - ' + room.org_unit.line2;
          }

          return room;
        });

        return rooms;
      }

      return [];
    },
    roomReportLabel: function roomReportLabel() {
      if (this.roomReportRoomId) {
        return this.$roomService.getRoom(this.roomReportRoomId).label;
      }
      return '';
    },
    roomReportTableHeaders: function roomReportTableHeaders() {
      if (this.roomReportRoomId) {
        var headers = [{
          text: "Status",
          align: "center",
          sortable: false,
          value: "room_status"
        }, {
          text: "Date",
          align: "left",
          sortable: false,
          value: "timestamp"
        }, {
          text: "Notes",
          align: "left",
          sortable: false,
          value: "room_status"
        }];
        return headers;
      }
      return [];
    },
    roomReportTableItems: function roomReportTableItems() {
      var _this2 = this;

      if (this.roomReportRoomId) {
        return this.$reportService.reports.filter(function (it) {
          return it.room_id == _this2.roomReportRoomId;
        }).reverse().map(function (report) {
          report.inventory = _this2.$roomService.getRoomInventory(report.room_id).filter(function (feature) {
            return report[feature.featureId] === false || report[feature.featureId + '_issue_description'];
          });
          if (!report.inventory.length) {
            report.clean_report = true;
            report.clean_report_issue_description = '';
            report.inventory.push({
              featureId: 'clean_report',
              featureName: 'No Issues Reported'
            });
          }
          return report;
        });
      }
      return [];
    },
    roomOwners: function roomOwners() {
      var rooms = this.$roomService.rooms;
      var owners = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.filter(function (it) {
        return !!it.netid_primary_owner && !!it.primary_contact_name;
      }).map(function (it) {
        return {
          value: it.netid_primary_owner,
          label: it.primary_contact_name
        };
      }).concat(rooms.filter(function (it) {
        return !!it.netid_secondary_owner && !!it.secondary_contact_name;
      }).map(function (it) {
        return {
          value: it.netid_secondary_owner,
          label: it.secondary_contact_name
        };
      }))));
      return owners;
    },
    roomOrgUnits: function roomOrgUnits() {
      var rooms = this.$roomService.rooms;
      var orgUnits = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms.filter(function (it) {
        return !!it.customer_or_owner;
      }).map(function (it) {
        return it.customer_or_owner;
      }).concat(rooms.filter(function (it) {
        return !!it.customer_or_owner && !!it.secondary_customer_or_owner;
      }).map(function (it) {
        return it.customer_or_owner + " - " + it.secondary_customer_or_owner;
      })))).sort();
      return orgUnits;
    },
    viewerIsRoomOwner: function viewerIsRoomOwner() {
      var _this3 = this;

      return !!this.roomOwners.filter(function (it) {
        return it.value == _this3.$auth.user().uid;
      }).length;
    },
    showDepartmentUnit: function showDepartmentUnit() {
      return !!this.roomOrgUnits.length;
    },
    lastChecked: function lastChecked() {
      var prefix = 'Last Updated: ';
      if (this.$roomService.rooms) {
        var lastRoomsChecked = this.$roomService.rooms.filter(function (it) {
          return !!it.last_checked;
        }).map(function (it) {
          return it.last_checked;
        }).sort().reverse();
        if (lastRoomsChecked.length) {
          return prefix + __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(lastRoomsChecked[0], 'x').format('M/D/YY') + ' at ' + __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(lastRoomsChecked[0], 'x').format('h:mma');
        }
        return prefix + 'Never';
      }
      return 'Loading...';
    }
  },
  watch: {
    rawSearchTerms: function rawSearchTerms() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(this.finishSearchDebounce, this.debouncePeriod);
    }
  },
  filters: {
    date: function date(timestamp) {
      return timestamp ? __WEBPACK_IMPORTED_MODULE_2_moment_business_days___default()(timestamp, 'x').format('MM/DD/YYYY h:mma') : 'Never';
    }
  }
});

/***/ }),

/***/ "toSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_ENDPOINT_BASE_URL */
/* unused harmony export API_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_ENDPOINT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_ENDPOINT_STATUS_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_ENDPOINT_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_ENDPOINT_GENERATE_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_ENDPOINT_TEAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_ENDPOINT_SMARTSHEETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ENDPOINT_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_ENDPOINT_LOGOUT; });
/* unused harmony export API_ENDPOINT_PING */
var API_ENDPOINT_URL = 'https://api.roomready.northwestern.edu';
var API_ENDPOINT_ENV_PATH = '';
var ENV = "development";

switch (ENV) {
  case 'local':
    API_ENDPOINT_URL = 'https://local.api.roomready.mtiapp.northwestern.edu:3000';
    API_ENDPOINT_ENV_PATH = '/local';
    break;

  case 'development':
    API_ENDPOINT_ENV_PATH = '/dev';
    break;

  case 'main': // fallthrough
  case 'prod': // fallthrough
  case 'production':
    API_ENDPOINT_ENV_PATH = '/prod';
    break;

  default:
    console.error('E_NODE_ENV_IS_INVALID: ' + ENV);
    break;
}

var API_ENDPOINT_BASE_URL = API_ENDPOINT_URL + API_ENDPOINT_ENV_PATH;
var API_VERSION = '2';
var API_ENDPOINT_REPORT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/report';
var API_ENDPOINT_STATUS_REPORTS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/status-report';
var API_ENDPOINT_ROOMS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/rooms';
var API_ENDPOINT_GENERATE_REPORT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/generate-report';
var API_ENDPOINT_TEAMS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/teams';
var API_ENDPOINT_SMARTSHEETS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/sheets';
var API_ENDPOINT_AUTH = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/authenticate';
var API_ENDPOINT_LOGOUT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/logout';
var API_ENDPOINT_PING = API_ENDPOINT_BASE_URL + '/ping';

/***/ }),

/***/ "uf1r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/AkkuratPro-Regular.70bf797.ttf";

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uuud":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5ZXH");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("48b1c6bb", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d57840f2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuccinctReports.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d57840f2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuccinctReports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vjNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SYNC_ENQUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SYNC_DEQUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SYNC_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROOMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ROOMS_INVENTORY_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROOMS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROOMS_INVENTORY_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TEAMS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TEAMS_CLEAR; });
var SYNC_ENQUEUE = 'SYNC_ENQUEUE';
var SYNC_DEQUEUE = 'SYNC_DEQUEUE';
var SYNC_CLEAR = 'SYNC_CLEAR';

var ROOMS_UPDATE = 'ROOMS_UPDATE';
var ROOMS_INVENTORY_UPDATE = 'ROOMS_INVENTORY_UPDATE';
var ROOMS_CLEAR = 'ROOMS_CLEAR';
var ROOMS_INVENTORY_CLEAR = 'ROOMS_INVENTORY_CLEAR';

var TEAMS_UPDATE = 'TEAMS_UPDATE';
var TEAMS_CLEAR = 'TEAMS_CLEAR';

/***/ }),

/***/ "x7p7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("SVxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beffe230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("n9Os");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beffe230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/MainMenu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-beffe230", Component.options)
  } else {
    hotAPI.reload("data-v-beffe230", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__ = __webpack_require__("x7p7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'rr-main-menu': __WEBPACK_IMPORTED_MODULE_1__components_MainMenu_vue__["a" /* default */]
  },
  computed: {
    teamName: function teamName() {
      if (!!this.$teamService.currentTeam) {
        return this.$teamService.currentTeam.teamName || false;
      }
      return false;
    },
    team: function team() {
      if (!!this.$teamService.currentTeam) {
        return this.$teamService.currentTeam;
      }
      return false;
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef68022e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("6MKK");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef68022e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ef68022e", Component.options)
  } else {
    hotAPI.reload("data-v-ef68022e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xUkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlashMessage_vue__ = __webpack_require__("e/uT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ce9aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlashMessage_vue__ = __webpack_require__("pgH9");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("0jRs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlashMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ce9aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlashMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/FlashMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29ce9aa7", Component.options)
  } else {
    hotAPI.reload("data-v-29ce9aa7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yJkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MutationTypes__ = __webpack_require__("vjNh");


var _mutations;



var state = {
  teams: [],
  schemaVersion: '2.0'
};

var getters = {
  teams: function teams(state) {
    return state.teams;
  }
};

var actions = {
  updateTeams: function updateTeams(_ref, items) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["i" /* TEAMS_UPDATE */], items);
  },
  clearCache: function clearCache(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__MutationTypes__["h" /* TEAMS_CLEAR */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__MutationTypes__["i" /* TEAMS_UPDATE */], function (state, _ref3) {
  var items = _ref3.items;

  if (items.length) {
    state.teams = items;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__MutationTypes__["h" /* TEAMS_CLEAR */], function (state) {
  state.teams = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ybql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Load TMP footprints services and categories fields.
// import * as FOOTPRINTS_SERVICES_AND_CATEGORIES from '@/data/sample-footprints-service-categories.json'

// TODO: Nick thinks status should be radio buttons, start in null state
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Report",
  data: function data() {
    return {
      room: {},
      formValid: false,
      inventory: [],
      form: __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].$roomService.getRoomInventoryForm(this.roomId),
      roomPickerRedirectDelaySeconds: 3,
      thankYouDialog: false
    };
  },

  props: {
    teamId: {
      type: String,
      required: true
    },
    roomId: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    loadData: function loadData() {
      this.room = this.$roomService.getRoom(this.roomId);
      this.inventory = this.$roomService.getRoomInventory(this.roomId);
    },
    submitReport: function submitReport() {
      if (this.$refs.form.validate()) {
        this.thankYouDialog = true;
        setTimeout(this.sendReport, (this.roomPickerRedirectDelaySeconds + 1) * 1000);
        setTimeout(this.goToRoomPicker, this.roomPickerRedirectDelaySeconds * 1000);
      }
    },
    sendReport: function sendReport() {
      // Send report to sync service
      this.$syncService.add(this.submissionData);
    },
    goToRoomPicker: function goToRoomPicker() {
      // Redirect to room picker to select another room
      var teamId = this.teamId;
      this.$router.push({
        path: "/" + teamId + "/room"
      });
    },
    showDialog: function showDialog(field) {
      field.issueDialog = true;
    },
    saveIssueDialog: function saveIssueDialog(field) {
      field.issueDialog = false;
      if (typeof field.issueDescription === "string" && field.issueDescription.length && field.status === null) {
        field.status = false;
      }
    },
    deleteIssueDialog: function deleteIssueDialog(field) {
      field.issueDescription = "";
      field.issueDialog = false;
    }
  },
  computed: {
    roomStatus: function roomStatus() {
      return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.featureStatusObject).filter(function (it) {
        return it !== true;
      }).length ? "working" : "broken";
    },
    submissionData: function submissionData() {
      var user = this.$auth.user();
      var userId = user.uid ? user.uid : "missing";
      return {
        room: this.room,
        roomId: this.roomId,
        label: this.room.label,
        userId: userId,
        user: user,
        form: this.form,
        roomStatus: this.roomStatus,
        teamId: this.teamId
      };
    },
    featureStatusObject: function featureStatusObject() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.form).map(function (it) {
        return [it[0], it[1].status];
      }).reduce(function (prev, curr) {
        prev[curr[0]] = curr[1];
        return prev;
      }, {});
    },
    featureStatusIncompleteCount: function featureStatusIncompleteCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.featureStatusObject).map(function (it) {
        return it[1];
      }).filter(function (it) {
        return it === null;
      }).length;
    }
  },
  watch: {
    featureStatusObject: {
      deep: true,
      handler: function handler(newVal, oldVal) {
        var _this = this;

        // Validate issue description whenever value of issue status is changed
        var changedFeatureId = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(newVal).filter(function (it) {
          return oldVal[it[0]] !== it[1];
        }).pop().reverse().pop();
        this.$nextTick(function (t) {
          _this.$refs[changedFeatureId + "_issueDescription"][0].validate();
        });
      }
    },
    featureStatusIncompleteCount: function featureStatusIncompleteCount(newVal, oldVal) {
      var _this2 = this;

      // Validate entire form once all status fields have been populated
      if (!newVal) {
        this.$nextTick(function (t) {
          _this2.$refs.form.validate();
        });
      }
    }
  }
});

/***/ }),

/***/ "zHxG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Campton-Bold.51f14df.woff2";

/***/ }),

/***/ "zLGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "report-page content-500" },
        [
          _c("h2", { staticClass: "page-title" }, [_vm._v("Sync Status")]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [
            _c("em", [
              _vm._v(
                "The reports below have not been properly synced to the server."
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn__sync_all",
                  attrs: { disabled: !_vm.items.length, color: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$syncService.sync()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("sync")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [_vm._v("Sync All")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "two-line": "" } },
            [
              _vm._l(_vm.items, function(item, index) {
                return [
                  _c(
                    "v-list-tile",
                    { key: index, staticClass: "field px-0" },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(item.room_id))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "grey--text text--darken-4" },
                            [
                              _vm._v(
                                "Last attempted at " +
                                  _vm._s(_vm._f("date")(item.lastSent))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: _vm.syncStatusIcons[item.status].color,
                                flat: "",
                                round: "",
                                icon: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$syncService.sync(item)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("sync")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  index + 1 < _vm.$syncService.items.length
                    ? _c("v-divider")
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4260014b", esExports)
  }
}

/***/ }),

/***/ "zaAj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Campton-Bold.f820d2a.woff";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bffb160b90f71282786f.js